msgid ""
msgstr ""
"POT-Creation-Date: 2025-05-03 21:08+0800\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: en\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: \n"

#: src/components/account-block.jsx:143
msgid "Locked"
msgstr ""

#. placeholder {0}: shortenNumber(statusesCount)
#: src/components/account-block.jsx:150
msgid "Posts: {0}"
msgstr ""

#. placeholder {0}: niceDateTime(lastStatusAt, { hideTime: true, })
#: src/components/account-block.jsx:155
msgid "Last posted: {0}"
msgstr ""

#: src/components/account-block.jsx:170
#: src/components/account-info.jsx:717
msgid "Automated"
msgstr ""

#: src/components/account-block.jsx:177
#: src/components/account-info.jsx:722
#: src/components/status.jsx:563
msgid "Group"
msgstr ""

#: src/components/account-block.jsx:187
msgid "Mutual"
msgstr ""

#: src/components/account-block.jsx:191
#: src/components/related-actions.jsx:923
msgid "Requested"
msgstr ""

#: src/components/account-block.jsx:195
#: src/components/related-actions.jsx:914
msgid "Following"
msgstr ""

#: src/components/account-block.jsx:199
#: src/components/related-actions.jsx:190
msgid "Follows you"
msgstr ""

#: src/components/account-block.jsx:207
msgid "{followersCount, plural, one {# follower} other {# followers}}"
msgstr ""

#: src/components/account-block.jsx:216
#: src/components/account-info.jsx:765
msgid "Verified"
msgstr ""

#. placeholder {0}: niceDateTime(createdAt, { hideTime: true, })
#. placeholder {0}: niceDateTime(createdAt, { hideTime: true, })
#: src/components/account-block.jsx:231
#: src/components/account-info.jsx:904
msgid "Joined <0>{0}</0>"
msgstr ""

#: src/components/account-handle-info.jsx:18
msgid "username"
msgstr ""

#: src/components/account-handle-info.jsx:22
msgid "server domain name"
msgstr ""

#: src/components/account-info.jsx:124
msgid "View profile"
msgstr "View profile"

#: src/components/account-info.jsx:392
msgid "Unable to load account."
msgstr "Unable to load account."

#: src/components/account-info.jsx:407
msgid "Go to account page"
msgstr "Go to account page"

#: src/components/account-info.jsx:436
#: src/components/account-info.jsx:787
#: src/components/compose.jsx:1974
#: src/pages/settings.jsx:325
#: src/utils/visibility-text.jsx:7
msgid "Followers"
msgstr "Followers"

#. js-lingui-explicit-id
#: src/components/account-info.jsx:440
#: src/components/account-info.jsx:842
msgid "following.stats"
msgstr "Following"

#: src/components/account-info.jsx:443
#: src/pages/account-statuses.jsx:496
#: src/pages/search.jsx:345
#: src/pages/search.jsx:492
msgid "Posts"
msgstr ""

#: src/components/account-info.jsx:451
#: src/components/media-alt-modal.jsx:55
#: src/components/media-attachment.jsx:428
#: src/components/media-modal.jsx:363
#: src/components/related-actions.jsx:263
#: src/components/status.jsx:2089
#: src/components/status.jsx:2106
#: src/components/status.jsx:2239
#: src/components/status.jsx:2937
#: src/components/status.jsx:2940
#: src/pages/account-statuses.jsx:544
#: src/pages/accounts.jsx:127
#: src/pages/hashtag.jsx:203
#: src/pages/list.jsx:171
#: src/pages/public.jsx:116
#: src/pages/scheduled-posts.jsx:89
#: src/pages/status.jsx:1464
#: src/pages/trending.jsx:474
msgid "More"
msgstr ""

#: src/components/account-info.jsx:463
msgid "<0>{displayName}</0> has indicated that their new account is now:"
msgstr "<0>{displayName}</0> has indicated that their new account is now:"

#: src/components/account-info.jsx:608
#: src/components/related-actions.jsx:491
msgid "Handle copied"
msgstr "Handle copied"

#: src/components/account-info.jsx:611
#: src/components/related-actions.jsx:494
msgid "Unable to copy handle"
msgstr "Unable to copy handle"

#: src/components/account-info.jsx:617
#: src/components/related-actions.jsx:500
msgid "Copy handle"
msgstr ""

#: src/components/account-info.jsx:635
#: src/components/related-actions.jsx:245
#: src/components/related-actions.jsx:565
#: src/components/shortcuts-settings.jsx:1083
msgid "QR code"
msgstr "QR code"

#: src/components/account-info.jsx:641
msgid "Go to original profile page"
msgstr ""

#: src/components/account-info.jsx:659
msgid "View profile image"
msgstr "View profile image"

#: src/components/account-info.jsx:677
msgid "View profile header"
msgstr "View profile header"

#: src/components/account-info.jsx:693
#: src/components/edit-profile-sheet.jsx:92
#: src/components/related-actions.jsx:817
msgid "Edit profile"
msgstr ""

#: src/components/account-info.jsx:712
msgid "In Memoriam"
msgstr ""

#: src/components/account-info.jsx:794
#: src/components/account-info.jsx:852
msgid "This user has chosen to not make this information available."
msgstr "This user has chosen to not make this information available."

#. placeholder {0}: shortenNumber(followersCount)
#. placeholder {1}: shortenNumber(followersCount)
#: src/components/account-info.jsx:814
msgid "{followersCount, plural, one {<0>{0}</0> Follower} other {<1>{1}</1> Followers}}"
msgstr "{followersCount, plural, one {<0>{0}</0> Follower} other {<1>{1}</1> Followers}}"

#. placeholder {0}: shortenNumber(followingCount)
#: src/components/account-info.jsx:858
msgid "{followingCount, plural, other {<0>{0}</0> Following}}"
msgstr "{followingCount, plural, other {<0>{0}</0> Following}}"

#. placeholder {0}: shortenNumber(statusesCount)
#. placeholder {1}: shortenNumber(statusesCount)
#: src/components/account-info.jsx:882
msgid "{statusesCount, plural, one {<0>{0}</0> Post} other {<1>{1}</1> Posts}}"
msgstr "{statusesCount, plural, one {<0>{0}</0> Post} other {<1>{1}</1> Posts}}"

#. placeholder {0}: ( postingStats.originals / postingStats.total ).toLocaleString(i18n.locale || undefined, { style: 'percent', })
#. placeholder {1}: ( postingStats.replies / postingStats.total ).toLocaleString(i18n.locale || undefined, { style: 'percent', })
#. placeholder {2}: ( postingStats.quotes / postingStats.total ).toLocaleString(i18n.locale || undefined, { style: 'percent', })
#. placeholder {3}: ( postingStats.boosts / postingStats.total ).toLocaleString(i18n.locale || undefined, { style: 'percent', })
#: src/components/account-info.jsx:939
msgid "{0} original posts, {1} replies, {2} quotes, {3} boosts"
msgstr "{0} original posts, {1} replies, {2} quotes, {3} boosts"

#. placeholder {0}: ( postingStats.originals / postingStats.total ).toLocaleString(i18n.locale || undefined, { style: 'percent', })
#. placeholder {1}: ( postingStats.replies / postingStats.total ).toLocaleString(i18n.locale || undefined, { style: 'percent', })
#. placeholder {2}: ( postingStats.boosts / postingStats.total ).toLocaleString(i18n.locale || undefined, { style: 'percent', })
#: src/components/account-info.jsx:956
msgid "{0} original posts, {1} replies, {2} boosts"
msgstr "{0} original posts, {1} replies, {2} boosts"

#. placeholder {0}: postingStats.total
#. placeholder {1}: postingStats.daysSinceLastPost
#. placeholder {2}: postingStats.daysSinceLastPost
#. placeholder {3}: postingStats.daysSinceLastPost
#. placeholder {4}: postingStats.total
#. placeholder {5}: postingStats.total
#. placeholder {6}: postingStats.daysSinceLastPost
#: src/components/account-info.jsx:973
msgid "{0, plural, one {{1, plural, one {Last 1 post in the past 1 day} other {Last 1 post in the past {2} days}}} other {{3, plural, one {Last {4} posts in the past 1 day} other {Last {5} posts in the past {6} days}}}}"
msgstr "{0, plural, one {{1, plural, one {Last 1 post in the past 1 day} other {Last 1 post in the past {2} days}}} other {{3, plural, one {Last {4} posts in the past 1 day} other {Last {5} posts in the past {6} days}}}}"

#. placeholder {0}: postingStats.total
#. placeholder {1}: postingStats.total
#: src/components/account-info.jsx:989
msgid "{0, plural, one {Last 1 post in the past year(s)} other {Last {1} posts in the past year(s)}}"
msgstr "{0, plural, one {Last 1 post in the past year(s)} other {Last {1} posts in the past year(s)}}"

#: src/components/account-info.jsx:1047
#: src/pages/catchup.jsx:73
msgid "Original"
msgstr ""

#: src/components/account-info.jsx:1051
#: src/components/status.jsx:2666
#: src/pages/catchup.jsx:74
#: src/pages/catchup.jsx:1564
#: src/pages/catchup.jsx:2219
#: src/pages/status.jsx:1100
#: src/pages/status.jsx:1824
msgid "Replies"
msgstr ""

#: src/components/account-info.jsx:1056
#: src/components/quotes-modal.jsx:81
#: src/pages/catchup.jsx:75
#: src/pages/catchup.jsx:1567
msgid "Quotes"
msgstr "Quotes"

#: src/components/account-info.jsx:1061
#: src/pages/catchup.jsx:76
#: src/pages/catchup.jsx:1566
#: src/pages/catchup.jsx:2231
#: src/pages/settings.jsx:1224
msgid "Boosts"
msgstr ""

#: src/components/account-info.jsx:1067
msgid "Post stats unavailable."
msgstr "Post stats unavailable."

#: src/components/account-info.jsx:1094
msgid "View post stats"
msgstr "View post stats"

#: src/components/account-sheet.jsx:38
#: src/components/add-remove-lists-sheet.jsx:45
#: src/components/compose.jsx:1065
#: src/components/custom-emojis-modal.jsx:270
#: src/components/drafts.jsx:57
#: src/components/edit-profile-sheet.jsx:87
#: src/components/embed-modal.jsx:13
#: src/components/generic-accounts.jsx:151
#: src/components/gif-picker-modal.jsx:71
#: src/components/import-accounts-selection.jsx:81
#: src/components/import-export-accounts.jsx:108
#: src/components/keyboard-shortcuts-help.jsx:52
#: src/components/list-add-edit.jsx:37
#: src/components/media-alt-modal.jsx:43
#: src/components/media-attachment.jsx:384
#: src/components/media-modal.jsx:327
#: src/components/mention-modal.jsx:162
#: src/components/notification-service.jsx:157
#: src/components/open-link-sheet.jsx:51
#: src/components/post-embed-modal.jsx:196
#: src/components/private-note-sheet.jsx:36
#: src/components/qr-code-modal.jsx:33
#: src/components/qr-scanner-modal.jsx:257
#: src/components/quote-settings-sheet.jsx:61
#: src/components/quotes-modal.jsx:76
#: src/components/report-modal.jsx:118
#: src/components/shortcuts-settings.jsx:231
#: src/components/shortcuts-settings.jsx:584
#: src/components/shortcuts-settings.jsx:785
#: src/components/status.jsx:3239
#: src/components/status.jsx:3451
#: src/components/translated-bio-sheet.jsx:21
#: src/pages/accounts.jsx:45
#: src/pages/catchup.jsx:1701
#: src/pages/filters.jsx:225
#: src/pages/list.jsx:302
#: src/pages/notifications.jsx:937
#: src/pages/scheduled-posts.jsx:288
#: src/pages/settings.jsx:93
#: src/pages/status.jsx:1563
msgid "Close"
msgstr ""

#: src/components/add-remove-lists-sheet.jsx:50
#: src/components/related-actions.jsx:457
#: src/components/related-actions.jsx:467
msgid "Add/Remove from Lists"
msgstr ""

#: src/components/add-remove-lists-sheet.jsx:90
msgid "Unable to remove from list."
msgstr "Unable to remove from list."

#: src/components/add-remove-lists-sheet.jsx:91
msgid "Unable to add to list."
msgstr "Unable to add to list."

#: src/components/add-remove-lists-sheet.jsx:110
#: src/pages/lists.jsx:131
msgid "Unable to load lists."
msgstr ""

#: src/components/add-remove-lists-sheet.jsx:114
msgid "No lists."
msgstr ""

#: src/components/add-remove-lists-sheet.jsx:125
#: src/components/list-add-edit.jsx:41
#: src/pages/lists.jsx:62
msgid "New list"
msgstr ""

#: src/components/background-service.jsx:158
msgid "Cloak mode disabled"
msgstr ""

#: src/components/background-service.jsx:158
msgid "Cloak mode enabled"
msgstr ""

#. More from [Author]
#: src/components/byline.jsx:17
msgid "More from <0/>"
msgstr "More from <0/>"

#: src/components/columns.jsx:27
#: src/components/nav-menu.jsx:181
#: src/components/shortcuts-settings.jsx:140
#: src/components/timeline.jsx:464
#: src/pages/catchup.jsx:1000
#: src/pages/filters.jsx:90
#: src/pages/followed-hashtags.jsx:41
#: src/pages/home.jsx:54
#: src/pages/notifications.jsx:582
#: src/pages/scheduled-posts.jsx:74
msgid "Home"
msgstr ""

#: src/components/compose-button.jsx:150
#: src/compose.jsx:42
msgid "Compose"
msgstr ""

#: src/components/compose-button.jsx:177
#: src/components/nav-menu.jsx:265
#: src/pages/scheduled-posts.jsx:31
#: src/pages/scheduled-posts.jsx:78
msgid "Scheduled Posts"
msgstr "Scheduled Posts"

#: src/components/compose-button.jsx:190
msgid "Add to thread"
msgstr "Add to thread"

#. placeholder {0}: i + 1
#: src/components/compose-poll.jsx:43
msgid "Choice {0}"
msgstr "Choice {0}"

#: src/components/compose-poll.jsx:64
#: src/components/media-attachment.jsx:348
#: src/components/shortcuts-settings.jsx:727
#: src/pages/catchup.jsx:1198
#: src/pages/filters.jsx:413
msgid "Remove"
msgstr ""

#: src/components/compose-poll.jsx:80
#: src/components/compose.jsx:1678
#: src/components/mention-modal.jsx:220
#: src/components/shortcuts-settings.jsx:716
#: src/pages/list.jsx:388
msgid "Add"
msgstr ""

#: src/components/compose-poll.jsx:96
msgid "Multiple choice"
msgstr "Multiple choice"

#: src/components/compose-poll.jsx:99
msgid "Duration"
msgstr ""

#: src/components/compose-poll.jsx:129
msgid "Remove poll"
msgstr ""

#: src/components/compose.jsx:110
msgid "Take photo or video"
msgstr "Take photo or video"

#: src/components/compose.jsx:111
msgid "Add media"
msgstr "Add media"

#: src/components/compose.jsx:112
msgid "Add custom emoji"
msgstr ""

#: src/components/compose.jsx:113
msgid "Add GIF"
msgstr "Add GIF"

#: src/components/compose.jsx:114
msgid "Add poll"
msgstr ""

#: src/components/compose.jsx:115
msgid "Add content warning"
msgstr "Add content warning"

#: src/components/compose.jsx:116
msgid "Schedule post"
msgstr "Schedule post"

#: src/components/compose.jsx:550
msgid "You have unsaved changes. Discard this post?"
msgstr "You have unsaved changes. Discard this post?"

#. placeholder {0}: unsupportedFiles.length
#. placeholder {1}: unsupportedFiles[0].name
#. placeholder {2}: lf.format( unsupportedFiles.map((f) => f.name), )
#: src/components/compose.jsx:796
msgid "{0, plural, one {File {1} is not supported.} other {Files {2} are not supported.}}"
msgstr "{0, plural, one {File {1} is not supported.} other {Files {2} are not supported.}}"

#: src/components/compose.jsx:806
#: src/components/compose.jsx:824
#: src/components/compose.jsx:2105
#: src/components/file-picker-input.jsx:38
msgid "{maxMediaAttachments, plural, one {You can only attach up to 1 file.} other {You can only attach up to # files.}}"
msgstr ""

#: src/components/compose.jsx:1046
msgid "Pop out"
msgstr "Pop out"

#: src/components/compose.jsx:1053
msgid "Minimize"
msgstr "Minimize"

#: src/components/compose.jsx:1089
msgid "Looks like you closed the parent window."
msgstr "Looks like you closed the parent window."

#: src/components/compose.jsx:1096
msgid "Looks like you already have a compose field open in the parent window and currently publishing. Please wait for it to be done and try again later."
msgstr "Looks like you already have a compose field open in the parent window and currently publishing. Please wait for it to be done and try again later."

#: src/components/compose.jsx:1101
msgid "Looks like you already have a compose field open in the parent window. Popping in this window will discard the changes you made in the parent window. Continue?"
msgstr "Looks like you already have a compose field open in the parent window. Popping in this window will discard the changes you made in the parent window. Continue?"

#: src/components/compose.jsx:1147
msgid "Pop in"
msgstr "Pop in"

#. placeholder {0}: replyToStatus.account.acct || replyToStatus.account.username
#. placeholder {1}: rtf.format(-replyToStatusMonthsAgo, 'month')
#: src/components/compose.jsx:1157
msgid "Replying to @{0}’s post (<0>{1}</0>)"
msgstr ""

#. placeholder {0}: replyToStatus.account.acct || replyToStatus.account.username
#: src/components/compose.jsx:1167
msgid "Replying to @{0}’s post"
msgstr ""

#: src/components/compose.jsx:1180
msgid "Editing source post"
msgstr ""

#: src/components/compose.jsx:1249
msgid "Poll must have at least 2 options"
msgstr "Poll must have at least 2 options"

#: src/components/compose.jsx:1253
msgid "Some poll choices are empty"
msgstr "Some poll choices are empty"

#: src/components/compose.jsx:1266
msgid "Some media have no descriptions. Continue?"
msgstr "Some media have no descriptions. Continue?"

#: src/components/compose.jsx:1318
msgid "Attachment #{i} failed"
msgstr "Attachment #{i} failed"

#: src/components/compose.jsx:1445
#: src/components/status.jsx:2433
#: src/components/timeline.jsx:990
msgid "Content warning"
msgstr ""

#: src/components/compose.jsx:1466
#: src/components/compose.jsx:1612
#: src/components/edit-profile-sheet.jsx:323
#: src/components/import-accounts-selection.jsx:175
#: src/components/open-link-sheet.jsx:74
#: src/components/private-note-sheet.jsx:94
#: src/components/quote-suggestion.jsx:35
msgid "Cancel"
msgstr ""

#: src/components/compose.jsx:1474
msgid "Post your reply"
msgstr "Post your reply"

#: src/components/compose.jsx:1476
msgid "Edit your post"
msgstr "Edit your post"

#: src/components/compose.jsx:1478
msgid "Ask a question"
msgstr "Ask a question"

#: src/components/compose.jsx:1479
msgid "What are you doing?"
msgstr "What are you doing?"

#: src/components/compose.jsx:1552
msgid "Mark media as sensitive"
msgstr ""

#: src/components/compose.jsx:1592
msgid "Posting on <0/>"
msgstr "Posting on <0/>"

#: src/components/compose.jsx:1894
#: src/components/quote-settings-sheet.jsx:82
#: src/components/status.jsx:297
#: src/pages/settings.jsx:367
msgid "Anyone can quote"
msgstr "Anyone can quote"

#: src/components/compose.jsx:1897
#: src/components/quote-settings-sheet.jsx:85
#: src/components/status.jsx:298
#: src/pages/settings.jsx:370
msgid "Your followers can quote"
msgstr "Your followers can quote"

#: src/components/compose.jsx:1900
#: src/components/quote-settings-sheet.jsx:88
#: src/components/status.jsx:299
#: src/pages/settings.jsx:373
msgid "Only you can quote"
msgstr "Only you can quote"

#: src/components/compose.jsx:1940
msgid "Quotes can't be embedded in private mentions."
msgstr "Quotes can't be embedded in private mentions."

#: src/components/compose.jsx:1962
#: src/pages/settings.jsx:319
#: src/utils/visibility-text.jsx:4
msgid "Public"
msgstr ""

#: src/components/compose.jsx:1967
#: src/components/nav-menu.jsx:349
#: src/components/shortcuts-settings.jsx:166
#: src/utils/visibility-text.jsx:5
msgid "Local"
msgstr ""

#: src/components/compose.jsx:1971
#: src/pages/settings.jsx:322
#: src/utils/visibility-text.jsx:6
msgid "Quiet public"
msgstr "Quiet public"

#: src/components/compose.jsx:1977
#: src/components/status.jsx:2313
#: src/utils/visibility-text.jsx:8
msgid "Private mention"
msgstr ""

#: src/components/compose.jsx:2029
msgid "Schedule"
msgstr "Schedule"

#: src/components/compose.jsx:2031
#: src/components/keyboard-shortcuts-help.jsx:164
#: src/components/status.jsx:1056
#: src/components/status.jsx:1090
#: src/components/status.jsx:2065
#: src/components/status.jsx:2066
#: src/components/status.jsx:2794
#: src/components/status.jsx:2806
msgid "Reply"
msgstr ""

#: src/components/compose.jsx:2033
msgid "Update"
msgstr "Update"

#: src/components/compose.jsx:2034
msgctxt "Submit button in composer"
msgid "Post"
msgstr "Post"

#: src/components/compose.jsx:2117
msgid "Downloading GIF…"
msgstr "Downloading GIF…"

#: src/components/compose.jsx:2145
msgid "Failed to download GIF"
msgstr "Failed to download GIF"

#. placeholder {0}: i18n.number(emojis.length - max)
#: src/components/custom-emojis-modal.jsx:103
msgid "{0} more…"
msgstr ""

#: src/components/custom-emojis-modal.jsx:276
msgid "Custom emojis"
msgstr ""

#: src/components/custom-emojis-modal.jsx:296
msgid "Search emoji"
msgstr "Search emoji"

#: src/components/custom-emojis-modal.jsx:327
msgid "Error loading custom emojis"
msgstr ""

#: src/components/custom-emojis-modal.jsx:338
msgid "Recently used"
msgstr "Recently used"

#: src/components/custom-emojis-modal.jsx:339
msgid "Others"
msgstr "Others"

#: src/components/custom-emojis-modal.jsx:358
msgid "Zoom out"
msgstr "Zoom out"

#: src/components/custom-emojis-modal.jsx:366
msgid "Zoom in"
msgstr "Zoom in"

#: src/components/drafts.jsx:62
#: src/pages/settings.jsx:728
msgid "Unsent drafts"
msgstr ""

#: src/components/drafts.jsx:67
msgid "Looks like you have unsent drafts. Let's continue where you left off."
msgstr ""

#: src/components/drafts.jsx:101
msgid "Delete this draft?"
msgstr ""

#: src/components/drafts.jsx:116
msgid "Error deleting draft! Please try again."
msgstr ""

#: src/components/drafts.jsx:126
#: src/components/list-add-edit.jsx:188
#: src/components/status.jsx:1598
#: src/pages/filters.jsx:603
#: src/pages/scheduled-posts.jsx:398
msgid "Delete…"
msgstr ""

#: src/components/drafts.jsx:147
msgid "Error fetching reply-to status!"
msgstr ""

#: src/components/drafts.jsx:159
msgid "Error fetching quoted status!"
msgstr "Error fetching quoted status!"

#: src/components/drafts.jsx:187
msgid "Delete all drafts?"
msgstr ""

#: src/components/drafts.jsx:205
msgid "Error deleting drafts! Please try again."
msgstr ""

#: src/components/drafts.jsx:217
msgid "Delete all…"
msgstr ""

#: src/components/drafts.jsx:225
msgid "No drafts found."
msgstr ""

#: src/components/drafts.jsx:263
#: src/pages/catchup.jsx:2078
msgid "Poll"
msgstr ""

#: src/components/drafts.jsx:266
#: src/pages/account-statuses.jsx:376
msgid "Media"
msgstr ""

#: src/components/drafts.jsx:270
#: src/components/keyboard-shortcuts-help.jsx:193
#: src/components/status.jsx:719
msgid "Quote"
msgstr ""

#: src/components/edit-history-controls.jsx:21
msgid "Edit History Snapshots"
msgstr "Edit History Snapshots"

#: src/components/edit-history-controls.jsx:35
#: src/components/gif-picker-modal.jsx:207
#: src/components/media-modal.jsx:469
#: src/components/timeline.jsx:903
msgid "Previous"
msgstr ""

#: src/components/edit-history-controls.jsx:47
#: src/components/gif-picker-modal.jsx:225
#: src/components/media-modal.jsx:488
#: src/components/timeline.jsx:920
msgid "Next"
msgstr ""

#: src/components/edit-history-controls.jsx:57
msgid "Exit"
msgstr "Exit"

#: src/components/edit-profile-sheet.jsx:147
msgid "Unable to update profile."
msgstr "Unable to update profile."

#: src/components/edit-profile-sheet.jsx:154
msgid "Header picture"
msgstr "Header picture"

#: src/components/edit-profile-sheet.jsx:206
msgid "Profile picture"
msgstr "Profile picture"

#: src/components/edit-profile-sheet.jsx:258
#: src/components/list-add-edit.jsx:106
msgid "Name"
msgstr ""

#: src/components/edit-profile-sheet.jsx:271
msgid "Bio"
msgstr ""

#: src/components/edit-profile-sheet.jsx:284
msgid "Extra fields"
msgstr ""

#: src/components/edit-profile-sheet.jsx:290
msgid "Label"
msgstr ""

#: src/components/edit-profile-sheet.jsx:293
msgid "Content"
msgstr ""

#: src/components/edit-profile-sheet.jsx:326
#: src/components/list-add-edit.jsx:152
#: src/components/quote-settings-sheet.jsx:92
#: src/components/shortcuts-settings.jsx:716
#: src/pages/filters.jsx:570
#: src/pages/notifications.jsx:1003
msgid "Save"
msgstr ""

#: src/components/embed-modal.jsx:18
msgid "Open in new window"
msgstr ""

#. placeholder {0}: info.username
#: src/components/endorsements.jsx:72
msgid "Profiles featured by @{0}"
msgstr "Profiles featured by @{0}"

#: src/components/endorsements.jsx:98
msgid "No featured profiles."
msgstr "No featured profiles."

#: src/components/follow-request-buttons.jsx:43
#: src/pages/notifications.jsx:987
msgid "Accept"
msgstr ""

#: src/components/follow-request-buttons.jsx:69
msgid "Reject"
msgstr ""

#: src/components/follow-request-buttons.jsx:76
#: src/pages/notifications.jsx:1271
msgid "Accepted"
msgstr ""

#: src/components/follow-request-buttons.jsx:80
msgid "Rejected"
msgstr ""

#: src/components/generic-accounts.jsx:154
#: src/components/notification.jsx:467
#: src/pages/accounts.jsx:50
#: src/pages/search.jsx:335
#: src/pages/search.jsx:368
msgid "Accounts"
msgstr ""

#: src/components/generic-accounts.jsx:214
#: src/components/quotes-modal.jsx:128
#: src/components/timeline.jsx:546
#: src/pages/list.jsx:321
#: src/pages/notifications.jsx:917
#: src/pages/search.jsx:562
#: src/pages/status.jsx:1597
msgid "Show more…"
msgstr ""

#: src/components/generic-accounts.jsx:219
#: src/components/quotes-modal.jsx:132
#: src/components/timeline.jsx:551
#: src/pages/search.jsx:567
msgid "The end."
msgstr ""

#: src/components/generic-accounts.jsx:236
#: src/components/mention-modal.jsx:233
msgid "Error loading accounts"
msgstr ""

#: src/components/generic-accounts.jsx:240
msgid "Nothing to show"
msgstr ""

#: src/components/gif-picker-modal.jsx:86
msgid "Search GIFs"
msgstr "Search GIFs"

#: src/components/gif-picker-modal.jsx:101
msgid "Powered by GIPHY"
msgstr "Powered by GIPHY"

#: src/components/gif-picker-modal.jsx:109
msgid "Type to search GIFs"
msgstr ""

#: src/components/gif-picker-modal.jsx:242
msgid "Error loading GIFs"
msgstr ""

#: src/components/import-accounts-selection.jsx:86
msgid "Select accounts to import"
msgstr "Select accounts to import"

#: src/components/import-accounts-selection.jsx:117
msgid "Select all"
msgstr "Select all"

#: src/components/import-accounts-selection.jsx:158
msgid "Existing"
msgstr "Existing"

#: src/components/import-accounts-selection.jsx:183
msgid "{selectedCount, plural, one {Import # account} other {Import # accounts}}"
msgstr "{selectedCount, plural, one {Import # account} other {Import # accounts}}"

#: src/components/import-export-accounts.jsx:52
msgid "Export failed"
msgstr "Export failed"

#: src/components/import-export-accounts.jsx:72
msgid "Import failed"
msgstr "Import failed"

#: src/components/import-export-accounts.jsx:113
msgid "Import/Export <0>Accounts</0>"
msgstr "Import/Export <0>Accounts</0>"

#: src/components/import-export-accounts.jsx:128
#: src/components/shortcuts-settings.jsx:800
msgid "Import"
msgstr ""

#: src/components/import-export-accounts.jsx:149
#: src/components/shortcuts-settings.jsx:1050
msgid "Export"
msgstr ""

#. placeholder {0}: accounts.length
#: src/components/import-export-accounts.jsx:153
msgid "{0, plural, one {# account} other {# accounts}}"
msgstr "{0, plural, one {# account} other {# accounts}}"

#: src/components/import-export-accounts.jsx:165
msgid "No login information or account access details are stored in the exported files. You will need to log in again for each account after importing."
msgstr "No login information or account access details are stored in the exported files. You will need to log in again for each account after importing."

#: src/components/keyboard-shortcuts-help.jsx:16
msgid "<0>{key1}</0> then <1>{key2}</1>"
msgstr "<0>{key1}</0> then <1>{key2}</1>"

#: src/components/keyboard-shortcuts-help.jsx:56
#: src/components/nav-menu.jsx:368
#: src/pages/catchup.jsx:1739
msgid "Keyboard shortcuts"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:64
msgid "Keyboard shortcuts help"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:68
#: src/pages/catchup.jsx:1764
msgid "Next post"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:72
#: src/pages/catchup.jsx:1772
msgid "Previous post"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:76
msgid "Skip carousel to next post"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:78
msgid "<0>Shift</0> + <1>j</1>"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:84
msgid "Skip carousel to previous post"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:86
msgid "<0>Shift</0> + <1>k</1>"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:92
msgid "Load new posts"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:96
#: src/pages/catchup.jsx:1796
msgid "Open post details"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:98
msgid "<0>Enter</0> or <1>o</1>"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:105
msgid "Expand content warning or<0/>toggle expanded/collapsed thread"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:114
msgid "Close post or dialogs"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:116
msgid "<0>Esc</0> or <1>Backspace</1>"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:122
msgid "Focus column in multi-column mode"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:124
msgid "<0>1</0> to <1>9</1>"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:130
msgid "Focus next column in multi-column mode"
msgstr "Focus next column in multi-column mode"

#: src/components/keyboard-shortcuts-help.jsx:134
msgid "Focus previous column in multi-column mode"
msgstr "Focus previous column in multi-column mode"

#: src/components/keyboard-shortcuts-help.jsx:138
msgid "Compose new post"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:142
msgid "Compose new post (new window)"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:145
msgid "<0>Shift</0> + <1>c</1>"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:151
msgid "Send post"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:153
msgid "<0>Ctrl</0> + <1>Enter</1> or <2>⌘</2> + <3>Enter</3>"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:160
#: src/components/nav-menu.jsx:337
#: src/components/search-form.jsx:208
#: src/components/shortcuts-settings.jsx:53
#: src/components/shortcuts-settings.jsx:180
#: src/pages/search.jsx:47
#: src/pages/search.jsx:317
msgid "Search"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:168
msgid "Reply (new window)"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:171
msgid "<0>Shift</0> + <1>r</1>"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:177
msgid "Like (favourite)"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:179
msgid "<0>l</0> or <1>f</1>"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:185
#: src/components/status.jsx:1126
#: src/components/status.jsx:2836
#: src/components/status.jsx:2891
msgid "Boost"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:187
msgid "<0>Shift</0> + <1>b</1>"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:197
#: src/components/status.jsx:1228
#: src/components/status.jsx:2916
#: src/components/status.jsx:2917
msgid "Bookmark"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:201
msgid "Toggle Cloak mode"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:203
msgid "<0>Shift</0> + <1>Alt</1> + <2>k</2>"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:209
msgid "Go to Home"
msgstr "Go to Home"

#: src/components/keyboard-shortcuts-help.jsx:213
msgid "Go to Notifications"
msgstr "Go to Notifications"

#: src/components/list-add-edit.jsx:41
msgid "Edit list"
msgstr ""

#: src/components/list-add-edit.jsx:97
msgid "Unable to edit list."
msgstr ""

#: src/components/list-add-edit.jsx:98
msgid "Unable to create list."
msgstr ""

#: src/components/list-add-edit.jsx:126
msgid "Show replies to list members"
msgstr ""

#: src/components/list-add-edit.jsx:129
msgid "Show replies to people I follow"
msgstr ""

#: src/components/list-add-edit.jsx:132
msgid "Don't show replies"
msgstr ""

#: src/components/list-add-edit.jsx:146
msgid "Hide posts on this list from Home/Following"
msgstr ""

#: src/components/list-add-edit.jsx:152
#: src/pages/filters.jsx:570
msgid "Create"
msgstr ""

#: src/components/list-add-edit.jsx:159
msgid "Delete this list?"
msgstr ""

#: src/components/list-add-edit.jsx:178
msgid "Unable to delete list."
msgstr ""

#: src/components/list-exclusive-badge.jsx:14
#: src/pages/list.jsx:179
#: src/pages/lists.jsx:107
msgid "Posts on this list are hidden from Home/Following"
msgstr "Posts on this list are hidden from Home/Following"

#: src/components/math-block.jsx:132
msgid "Unable to format math"
msgstr "Unable to format math"

#: src/components/math-block.jsx:146
msgid "Math expressions found."
msgstr "Math expressions found."

#. Action to switch from rendered math back to raw (LaTeX) markup
#: src/components/math-block.jsx:149
msgid "Show markup"
msgstr "Show markup"

#. Action to render math expressions from raw (LaTeX) markup
#: src/components/math-block.jsx:154
msgid "Format math"
msgstr "Format math"

#: src/components/media-alt-modal.jsx:48
#: src/components/media.jsx:51
msgid "Media description"
msgstr ""

#: src/components/media-alt-modal.jsx:67
#: src/components/status.jsx:1283
#: src/components/status.jsx:1292
#: src/components/translation-block.jsx:270
msgid "Translate"
msgstr ""

#: src/components/media-alt-modal.jsx:78
#: src/components/status.jsx:1313
msgid "Speak"
msgstr ""

#: src/components/media-attachment.jsx:198
msgid "Uploaded"
msgstr ""

#: src/components/media-attachment.jsx:211
msgid "Image description"
msgstr "Image description"

#: src/components/media-attachment.jsx:212
msgid "Video description"
msgstr "Video description"

#: src/components/media-attachment.jsx:213
msgid "Audio description"
msgstr "Audio description"

#. placeholder {0}: prettyBytes( imageSize, )
#. placeholder {0}: prettyBytes( videoSize, )
#. placeholder {1}: prettyBytes(imageSizeLimit)
#. placeholder {1}: prettyBytes(videoSizeLimit)
#: src/components/media-attachment.jsx:248
#: src/components/media-attachment.jsx:268
msgid "File size too large. Uploading might encounter issues. Try reduce the file size from {0} to {1} or lower."
msgstr "File size too large. Uploading might encounter issues. Try reduce the file size from {0} to {1} or lower."

#. placeholder {0}: i18n.number( width, )
#. placeholder {1}: i18n.number(height)
#. placeholder {2}: i18n.number(newWidth)
#. placeholder {3}: i18n.number( newHeight, )
#: src/components/media-attachment.jsx:260
#: src/components/media-attachment.jsx:280
msgid "Dimension too large. Uploading might encounter issues. Try reduce dimension from {0}×{1}px to {2}×{3}px."
msgstr "Dimension too large. Uploading might encounter issues. Try reduce dimension from {0}×{1}px to {2}×{3}px."

#: src/components/media-attachment.jsx:288
msgid "Frame rate too high. Uploading might encounter issues."
msgstr "Frame rate too high. Uploading might encounter issues."

#: src/components/media-attachment.jsx:365
#: src/compose.jsx:88
msgid "Error"
msgstr ""

#: src/components/media-attachment.jsx:390
msgid "Edit image description"
msgstr "Edit image description"

#: src/components/media-attachment.jsx:391
msgid "Edit video description"
msgstr "Edit video description"

#: src/components/media-attachment.jsx:392
msgid "Edit audio description"
msgstr "Edit audio description"

#: src/components/media-attachment.jsx:437
#: src/components/media-attachment.jsx:486
msgid "Generating description. Please wait…"
msgstr "Generating description. Please wait…"

#. placeholder {0}: e.message
#: src/components/media-attachment.jsx:457
msgid "Failed to generate description: {0}"
msgstr "Failed to generate description: {0}"

#: src/components/media-attachment.jsx:458
msgid "Failed to generate description"
msgstr "Failed to generate description"

#: src/components/media-attachment.jsx:470
#: src/components/media-attachment.jsx:476
#: src/components/media-attachment.jsx:522
msgid "Generate description…"
msgstr ""

#. placeholder {0}: e?.message ? `: ${e.message}` : ''
#: src/components/media-attachment.jsx:509
msgid "Failed to generate description{0}"
msgstr "Failed to generate description{0}"

#. placeholder {0}: localeCode2Text(lang)
#: src/components/media-attachment.jsx:524
msgid "({0}) <0>— experimental</0>"
msgstr ""

#: src/components/media-attachment.jsx:543
msgid "Done"
msgstr ""

#: src/components/media-modal.jsx:374
msgid "Open original media in new window"
msgstr ""

#: src/components/media-modal.jsx:378
msgid "Open original media"
msgstr ""

#: src/components/media-modal.jsx:394
msgid "Attempting to describe image. Please wait…"
msgstr ""

#: src/components/media-modal.jsx:409
msgid "Failed to describe image"
msgstr ""

#: src/components/media-modal.jsx:419
msgid "Describe image…"
msgstr ""

#: src/components/media-modal.jsx:443
msgid "View post"
msgstr ""

#: src/components/media-post.jsx:127
msgid "Sensitive media"
msgstr ""

#: src/components/media-post.jsx:132
msgid "Filtered: {filterTitleStr}"
msgstr ""

#: src/components/media-post.jsx:133
#: src/components/status-compact.jsx:70
#: src/components/status.jsx:3377
#: src/components/status.jsx:3455
#: src/components/timeline.jsx:979
#: src/pages/catchup.jsx:79
#: src/pages/catchup.jsx:2022
msgid "Filtered"
msgstr ""

#: src/components/media.jsx:486
msgid "Open file"
msgstr "Open file"

#: src/components/mention-modal.jsx:179
msgid "Search accounts"
msgstr "Search accounts"

#: src/components/modals.jsx:89
msgid "Post scheduled"
msgstr "Post scheduled"

#: src/components/modals.jsx:90
msgid "Post published. Check it out."
msgstr ""

#: src/components/modals.jsx:92
msgid "Reply scheduled"
msgstr "Reply scheduled"

#: src/components/modals.jsx:93
msgid "Reply posted. Check it out."
msgstr ""

#: src/components/modals.jsx:94
msgid "Post updated. Check it out."
msgstr ""

#: src/components/nav-menu.jsx:123
msgid "Menu"
msgstr ""

#: src/components/nav-menu.jsx:159
msgid "Reload page now to update?"
msgstr ""

#: src/components/nav-menu.jsx:171
msgid "New update available…"
msgstr ""

#. js-lingui-explicit-id
#: src/components/nav-menu.jsx:190
#: src/components/shortcuts-settings.jsx:141
#: src/pages/following.jsx:23
#: src/pages/following.jsx:156
msgid "following.title"
msgstr "Following"

#: src/components/nav-menu.jsx:197
#: src/pages/catchup.jsx:995
#: src/pages/welcome.jsx:146
msgid "Catch-up"
msgstr ""

#: src/components/nav-menu.jsx:204
#: src/components/shortcuts-settings.jsx:59
#: src/components/shortcuts-settings.jsx:147
#: src/pages/home.jsx:240
#: src/pages/mentions.jsx:21
#: src/pages/mentions.jsx:174
#: src/pages/settings.jsx:1216
#: src/pages/trending.jsx:384
msgid "Mentions"
msgstr ""

#: src/components/nav-menu.jsx:211
#: src/components/shortcuts-settings.jsx:50
#: src/components/shortcuts-settings.jsx:153
#: src/pages/filters.jsx:24
#: src/pages/home.jsx:86
#: src/pages/home.jsx:198
#: src/pages/notifications.jsx:111
#: src/pages/notifications.jsx:586
msgid "Notifications"
msgstr ""

#: src/components/nav-menu.jsx:214
msgid "New"
msgstr ""

#: src/components/nav-menu.jsx:225
msgid "Profile"
msgstr ""

#: src/components/nav-menu.jsx:233
#: src/components/shortcuts-settings.jsx:55
#: src/components/shortcuts-settings.jsx:196
#: src/pages/bookmarks.jsx:12
#: src/pages/bookmarks.jsx:26
msgid "Bookmarks"
msgstr ""

#: src/components/nav-menu.jsx:244
#: src/components/text-expander.jsx:215
msgid "More…"
msgstr ""

#: src/components/nav-menu.jsx:253
#: src/components/shortcuts-settings.jsx:56
#: src/components/shortcuts-settings.jsx:202
#: src/pages/catchup.jsx:1565
#: src/pages/catchup.jsx:2225
#: src/pages/favourites.jsx:12
#: src/pages/favourites.jsx:26
#: src/pages/settings.jsx:1220
msgid "Likes"
msgstr ""

#: src/components/nav-menu.jsx:259
#: src/pages/followed-hashtags.jsx:15
#: src/pages/followed-hashtags.jsx:45
msgid "Followed Hashtags"
msgstr ""

#: src/components/nav-menu.jsx:273
#: src/pages/account-statuses.jsx:342
#: src/pages/filters.jsx:55
#: src/pages/filters.jsx:94
#: src/pages/hashtag.jsx:344
msgid "Filters"
msgstr ""

#: src/components/nav-menu.jsx:281
msgid "Muted users"
msgstr ""

#: src/components/nav-menu.jsx:289
msgid "Muted users…"
msgstr ""

#: src/components/nav-menu.jsx:296
msgid "Blocked users"
msgstr ""

#: src/components/nav-menu.jsx:304
msgid "Blocked users…"
msgstr ""

#: src/components/nav-menu.jsx:316
msgid "Accounts…"
msgstr ""

#: src/components/nav-menu.jsx:326
#: src/pages/login.jsx:32
#: src/pages/login.jsx:199
#: src/pages/status.jsx:1000
#: src/pages/welcome.jsx:65
msgid "Log in"
msgstr ""

#: src/components/nav-menu.jsx:343
#: src/components/shortcuts-settings.jsx:58
#: src/components/shortcuts-settings.jsx:173
#: src/pages/trending.jsx:444
msgid "Trending"
msgstr ""

#: src/components/nav-menu.jsx:355
#: src/components/shortcuts-settings.jsx:166
msgid "Federated"
msgstr ""

#: src/components/nav-menu.jsx:378
msgid "Shortcuts / Columns…"
msgstr ""

#: src/components/nav-menu.jsx:388
#: src/components/nav-menu.jsx:402
msgid "Settings…"
msgstr ""

#: src/components/nav-menu.jsx:432
#: src/components/nav-menu.jsx:467
#: src/components/shortcuts-settings.jsx:51
#: src/components/shortcuts-settings.jsx:159
#: src/pages/list.jsx:127
#: src/pages/lists.jsx:18
#: src/pages/lists.jsx:54
msgid "Lists"
msgstr ""

#: src/components/nav-menu.jsx:440
#: src/components/shortcuts.jsx:243
#: src/pages/list.jsx:139
msgid "All Lists"
msgstr ""

#: src/components/notification-service.jsx:161
msgid "Notification"
msgstr ""

#: src/components/notification-service.jsx:167
msgid "This notification is from your other account."
msgstr ""

#: src/components/notification-service.jsx:196
msgid "View all notifications"
msgstr ""

#: src/components/notification.jsx:75
msgid "{account} reacted to your post with {emojiObject}"
msgstr ""

#: src/components/notification.jsx:82
msgid "{account} published a post."
msgstr ""

#. placeholder {0}: shortenNumber(count)
#. placeholder {1}: shortenNumber(count)
#: src/components/notification.jsx:90
msgid "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} boosted your reply.} other {{account} boosted your post.}}} other {{account} boosted {postsCount} of your posts.}}} other {{postType, select, reply {<0><1>{0}</1> people</0> boosted your reply.} other {<2><3>{1}</3> people</2> boosted your post.}}}}"
msgstr ""

#. placeholder {0}: shortenNumber(count)
#: src/components/notification.jsx:133
msgid "{count, plural, =1 {{account} followed you.} other {<0><1>{0}</1> people</0> followed you.}}"
msgstr ""

#: src/components/notification.jsx:147
msgid "{account} requested to follow you."
msgstr ""

#. placeholder {0}: shortenNumber(count)
#. placeholder {1}: shortenNumber(count)
#: src/components/notification.jsx:156
msgid "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} liked your reply.} other {{account} liked your post.}}} other {{account} liked {postsCount} of your posts.}}} other {{postType, select, reply {<0><1>{0}</1> people</0> liked your reply.} other {<2><3>{1}</3> people</2> liked your post.}}}}"
msgstr ""

#: src/components/notification.jsx:198
msgid "A poll you have voted in or created has ended."
msgstr ""

#: src/components/notification.jsx:199
msgid "A poll you have created has ended."
msgstr ""

#: src/components/notification.jsx:200
msgid "A poll you have voted in has ended."
msgstr ""

#: src/components/notification.jsx:203
msgid "{account} edited a post."
msgstr "{account} edited a post."

#: src/components/notification.jsx:205
msgid "A post you interacted with has been edited."
msgstr ""

#. placeholder {0}: shortenNumber(count)
#. placeholder {1}: shortenNumber(count)
#: src/components/notification.jsx:214
msgid "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} boosted & liked your reply.} other {{account} boosted & liked your post.}}} other {{account} boosted & liked {postsCount} of your posts.}}} other {{postType, select, reply {<0><1>{0}</1> people</0> boosted & liked your reply.} other {<2><3>{1}</3> people</2> boosted & liked your post.}}}}"
msgstr ""

#: src/components/notification.jsx:257
msgid "{account} edited a post you have quoted."
msgstr "{account} edited a post you have quoted."

#: src/components/notification.jsx:259
msgid "{account} signed up."
msgstr ""

#: src/components/notification.jsx:261
msgid "{account} reported {targetAccount}"
msgstr ""

#: src/components/notification.jsx:266
msgid "Lost connections with <0>{name}</0>."
msgstr ""

#: src/components/notification.jsx:272
msgid "Moderation warning"
msgstr ""

#: src/components/notification.jsx:277
msgid "Your {year} #Wrapstodon is here!"
msgstr "Your {year} #Wrapstodon is here!"

#: src/components/notification.jsx:283
msgid "An admin from <0>{from}</0> has suspended <1>{targetName}</1>, which means you can no longer receive updates from them or interact with them."
msgstr ""

#: src/components/notification.jsx:289
msgid "An admin from <0>{from}</0> has blocked <1>{targetName}</1>. Affected followers: {followersCount}, followings: {followingCount}."
msgstr ""

#: src/components/notification.jsx:295
msgid "You have blocked <0>{targetName}</0>. Removed followers: {followersCount}, followings: {followingCount}."
msgstr ""

#: src/components/notification.jsx:303
msgid "Your account has received a moderation warning."
msgstr ""

#: src/components/notification.jsx:304
msgid "Your account has been disabled."
msgstr ""

#: src/components/notification.jsx:305
msgid "Some of your posts have been marked as sensitive."
msgstr ""

#: src/components/notification.jsx:306
msgid "Some of your posts have been deleted."
msgstr ""

#: src/components/notification.jsx:307
msgid "Your posts will be marked as sensitive from now on."
msgstr ""

#: src/components/notification.jsx:308
msgid "Your account has been limited."
msgstr ""

#: src/components/notification.jsx:309
msgid "Your account has been suspended."
msgstr ""

#: src/components/notification.jsx:386
msgid "[Unknown notification type: {type}]"
msgstr ""

#: src/components/notification.jsx:463
#: src/components/status.jsx:1242
#: src/components/status.jsx:1252
msgid "Boosted/Liked by…"
msgstr ""

#: src/components/notification.jsx:464
msgid "Liked by…"
msgstr ""

#: src/components/notification.jsx:465
msgid "Boosted by…"
msgstr ""

#: src/components/notification.jsx:466
msgid "Followed by…"
msgstr ""

#: src/components/notification.jsx:547
#: src/components/notification.jsx:563
msgid "Learn more <0/>"
msgstr ""

#: src/components/notification.jsx:572
msgid "View #Wrapstodon"
msgstr "View #Wrapstodon"

#: src/components/notification.jsx:813
#: src/components/status.jsx:260
msgid "Read more →"
msgstr ""

#: src/components/open-link-sheet.jsx:30
#: src/components/related-actions.jsx:517
#: src/components/status.jsx:1404
msgid "Link copied"
msgstr ""

#: src/components/open-link-sheet.jsx:33
#: src/components/related-actions.jsx:520
#: src/components/status.jsx:1407
msgid "Unable to copy link"
msgstr ""

#: src/components/open-link-sheet.jsx:56
msgid "Open link?"
msgstr "Open link?"

#: src/components/open-link-sheet.jsx:78
#: src/components/post-embed-modal.jsx:232
#: src/components/related-actions.jsx:526
#: src/components/shortcuts-settings.jsx:1159
#: src/components/status.jsx:1413
msgid "Copy"
msgstr ""

#: src/components/open-link-sheet.jsx:82
#: src/components/related-actions.jsx:547
#: src/components/status.jsx:1435
msgid "Share…"
msgstr ""

#: src/components/open-link-sheet.jsx:92
msgid "Open"
msgstr "Open"

#: src/components/poll.jsx:113
msgid "Voted"
msgstr "Voted"

#: src/components/poll.jsx:119
msgid "{optionVotesCount, plural, one {# vote} other {# votes}}"
msgstr "{optionVotesCount, plural, one {# vote} other {# votes}}"

#: src/components/poll.jsx:139
#: src/components/poll.jsx:222
#: src/components/poll.jsx:226
msgid "Hide results"
msgstr "Hide results"

#: src/components/poll.jsx:188
msgid "Vote"
msgstr "Vote"

#: src/components/poll.jsx:208
#: src/components/poll.jsx:210
#: src/pages/scheduled-posts.jsx:100
#: src/pages/status.jsx:1453
#: src/pages/status.jsx:1476
msgid "Refresh"
msgstr ""

#: src/components/poll.jsx:222
#: src/components/poll.jsx:226
msgid "Show results"
msgstr "Show results"

#. placeholder {0}: shortenNumber(votesCount)
#. placeholder {1}: shortenNumber(votesCount)
#: src/components/poll.jsx:231
msgid "{votesCount, plural, one {<0>{0}</0> vote} other {<1>{1}</1> votes}}"
msgstr "{votesCount, plural, one {<0>{0}</0> vote} other {<1>{1}</1> votes}}"

#. placeholder {0}: shortenNumber(votersCount)
#. placeholder {1}: shortenNumber(votersCount)
#: src/components/poll.jsx:248
msgid "{votersCount, plural, one {<0>{0}</0> voter} other {<1>{1}</1> voters}}"
msgstr "{votersCount, plural, one {<0>{0}</0> voter} other {<1>{1}</1> voters}}"

#: src/components/poll.jsx:268
msgid "Ended <0/>"
msgstr "Ended <0/>"

#: src/components/poll.jsx:272
msgid "Ended"
msgstr "Ended"

#: src/components/poll.jsx:275
msgid "Ending <0/>"
msgstr "Ending <0/>"

#: src/components/poll.jsx:279
msgid "Ending"
msgstr "Ending"

#: src/components/post-embed-modal.jsx:201
#: src/components/status.jsx:1448
msgid "Embed post"
msgstr ""

#: src/components/post-embed-modal.jsx:206
msgid "HTML Code"
msgstr ""

#: src/components/post-embed-modal.jsx:223
msgid "HTML code copied"
msgstr ""

#: src/components/post-embed-modal.jsx:226
msgid "Unable to copy HTML code"
msgstr ""

#: src/components/post-embed-modal.jsx:238
msgid "Media attachments:"
msgstr ""

#: src/components/post-embed-modal.jsx:260
msgid "Account Emojis:"
msgstr ""

#: src/components/post-embed-modal.jsx:291
#: src/components/post-embed-modal.jsx:336
msgid "static URL"
msgstr ""

#: src/components/post-embed-modal.jsx:305
msgid "Emojis:"
msgstr ""

#: src/components/post-embed-modal.jsx:350
msgid "Notes:"
msgstr ""

#: src/components/post-embed-modal.jsx:354
msgid "This is static, unstyled and scriptless. You may need to apply your own styles and edit as needed."
msgstr ""

#: src/components/post-embed-modal.jsx:360
msgid "Polls are not interactive, becomes a list with vote counts."
msgstr ""

#: src/components/post-embed-modal.jsx:365
msgid "Media attachments can be images, videos, audios or any file types."
msgstr ""

#: src/components/post-embed-modal.jsx:371
msgid "Post could be edited or deleted later."
msgstr ""

#: src/components/post-embed-modal.jsx:377
msgid "Preview"
msgstr ""

#: src/components/post-embed-modal.jsx:386
msgid "Note: This preview is lightly styled."
msgstr ""

#. placeholder {0}: account?.username || account?.acct
#: src/components/private-note-sheet.jsx:41
msgid "Private note about <0>@{0}</0>"
msgstr ""

#: src/components/private-note-sheet.jsx:71
msgid "Unable to update private note."
msgstr "Unable to update private note."

#: src/components/private-note-sheet.jsx:99
msgid "Save & close"
msgstr ""

#: src/components/qr-code-modal.jsx:26
#: src/components/shortcuts-settings.jsx:833
msgid "Scan QR code"
msgstr "Scan QR code"

#: src/components/qr-scanner-modal.jsx:263
msgid "Unable to access camera. Please check permissions."
msgstr "Unable to access camera. Please check permissions."

#: src/components/quote-settings-sheet.jsx:37
#: src/pages/settings.jsx:358
msgid "Quote settings updated"
msgstr "Quote settings updated"

#: src/components/quote-settings-sheet.jsx:47
#: src/pages/settings.jsx:360
msgid "Failed to update quote settings"
msgstr "Failed to update quote settings"

#: src/components/quote-settings-sheet.jsx:66
msgid "Quote settings for this post"
msgstr "Quote settings for this post"

#: src/components/quote-suggestion.jsx:19
msgid "Turn link into a quote?"
msgstr "Turn link into a quote?"

#: src/components/quote-suggestion.jsx:37
msgid "Keep as link"
msgstr "Keep as link"

#: src/components/quote-suggestion.jsx:42
msgid "Replace current quote"
msgstr "Replace current quote"

#: src/components/quote-suggestion.jsx:44
msgid "Turn into quote"
msgstr "Turn into quote"

#: src/components/quotes-modal.jsx:149
msgid "Error loading quotes"
msgstr "Error loading quotes"

#: src/components/quotes-modal.jsx:153
msgid "No quotes yet"
msgstr "No quotes yet"

#: src/components/recent-searches.jsx:27
msgid "Cleared recent searches"
msgstr "Cleared recent searches"

#: src/components/recent-searches.jsx:49
#: src/components/search-form.jsx:332
msgid "Recent searches"
msgstr "Recent searches"

#: src/components/recent-searches.jsx:59
msgid "Clear all"
msgstr "Clear all"

#: src/components/recent-searches.jsx:94
#: src/pages/account-statuses.jsx:335
msgid "Clear"
msgstr ""

#: src/components/related-actions.jsx:39
msgid "Forever"
msgstr ""

#. placeholder {0}: niceDateTime(lastStatusAt, { hideTime: true, })
#: src/components/related-actions.jsx:194
msgid "Last post: <0>{0}</0>"
msgstr ""

#: src/components/related-actions.jsx:208
msgid "Muted"
msgstr ""

#: src/components/related-actions.jsx:213
msgid "Blocked"
msgstr ""

#: src/components/related-actions.jsx:222
msgid "Private note"
msgstr "Private note"

#: src/components/related-actions.jsx:296
msgid "Mention <0>@{username}</0>"
msgstr ""

#: src/components/related-actions.jsx:308
msgid "Translate bio"
msgstr ""

#: src/components/related-actions.jsx:319
msgid "Edit private note"
msgstr "Edit private note"

#: src/components/related-actions.jsx:319
msgid "Add private note"
msgstr "Add private note"

#: src/components/related-actions.jsx:339
msgid "Notifications enabled for @{username}'s posts."
msgstr "Notifications enabled for @{username}'s posts."

#: src/components/related-actions.jsx:340
msgid " Notifications disabled for @{username}'s posts."
msgstr " Notifications disabled for @{username}'s posts."

#: src/components/related-actions.jsx:352
msgid "Disable notifications"
msgstr "Disable notifications"

#: src/components/related-actions.jsx:353
msgid "Enable notifications"
msgstr "Enable notifications"

#: src/components/related-actions.jsx:370
msgid "Boosts from @{username} enabled."
msgstr "Boosts from @{username} enabled."

#: src/components/related-actions.jsx:371
msgid "Boosts from @{username} disabled."
msgstr "Boosts from @{username} disabled."

#: src/components/related-actions.jsx:382
msgid "Disable boosts"
msgstr "Disable boosts"

#: src/components/related-actions.jsx:382
msgid "Enable boosts"
msgstr "Enable boosts"

#: src/components/related-actions.jsx:401
msgid "@{username} is no longer featured on your profile."
msgstr "@{username} is no longer featured on your profile."

#: src/components/related-actions.jsx:411
msgid "@{username} is now featured on your profile."
msgstr "@{username} is now featured on your profile."

#: src/components/related-actions.jsx:419
msgid "Unable to unfeature @{username} on your profile."
msgstr "Unable to unfeature @{username} on your profile."

#: src/components/related-actions.jsx:423
msgid "Unable to feature @{username} on your profile."
msgstr "Unable to feature @{username} on your profile."

#: src/components/related-actions.jsx:432
msgid "Don't feature on profile"
msgstr "Don't feature on profile"

#: src/components/related-actions.jsx:433
#: src/pages/hashtag.jsx:333
msgid "Feature on profile"
msgstr ""

#: src/components/related-actions.jsx:442
#: src/components/related-actions.jsx:480
msgid "Show featured profiles"
msgstr "Show featured profiles"

#: src/components/related-actions.jsx:541
#: src/components/shortcuts-settings.jsx:1177
#: src/components/status.jsx:1429
msgid "Sharing doesn't seem to work."
msgstr ""

#: src/components/related-actions.jsx:583
msgid "Unmuted @{username}"
msgstr "Unmuted @{username}"

#: src/components/related-actions.jsx:595
msgid "Unmute <0>@{username}</0>"
msgstr "Unmute <0>@{username}</0>"

#: src/components/related-actions.jsx:611
msgid "Mute <0>@{username}</0>…"
msgstr ""

#. placeholder {0}: typeof MUTE_DURATIONS_LABELS[duration] === 'function' ? MUTE_DURATIONS_LABELS[duration]() : _(MUTE_DURATIONS_LABELS[duration])
#: src/components/related-actions.jsx:643
msgid "Muted @{username} for {0}"
msgstr "Muted @{username} for {0}"

#: src/components/related-actions.jsx:655
msgid "Unable to mute @{username}"
msgstr "Unable to mute @{username}"

#: src/components/related-actions.jsx:676
msgid "Remove <0>@{username}</0> from followers?"
msgstr ""

#: src/components/related-actions.jsx:696
msgid "@{username} removed from followers"
msgstr "@{username} removed from followers"

#: src/components/related-actions.jsx:708
msgid "Remove follower…"
msgstr ""

#: src/components/related-actions.jsx:719
msgid "Block <0>@{username}</0>?"
msgstr ""

#: src/components/related-actions.jsx:743
msgid "Unblocked @{username}"
msgstr "Unblocked @{username}"

#: src/components/related-actions.jsx:751
msgid "Blocked @{username}"
msgstr "Blocked @{username}"

#: src/components/related-actions.jsx:759
msgid "Unable to unblock @{username}"
msgstr "Unable to unblock @{username}"

#: src/components/related-actions.jsx:761
msgid "Unable to block @{username}"
msgstr "Unable to block @{username}"

#: src/components/related-actions.jsx:771
msgid "Unblock <0>@{username}</0>"
msgstr ""

#: src/components/related-actions.jsx:780
msgid "Block <0>@{username}</0>…"
msgstr ""

#: src/components/related-actions.jsx:797
msgid "Report <0>@{username}</0>…"
msgstr ""

#: src/components/related-actions.jsx:853
msgid "Withdraw follow request?"
msgstr "Withdraw follow request?"

#. placeholder {0}: info.acct || info.username
#: src/components/related-actions.jsx:854
msgid "Unfollow @{0}?"
msgstr "Unfollow @{0}?"

#: src/components/related-actions.jsx:917
msgid "Unfollow…"
msgstr ""

#: src/components/related-actions.jsx:926
msgid "Withdraw…"
msgstr ""

#: src/components/related-actions.jsx:933
#: src/components/related-actions.jsx:937
#: src/pages/hashtag.jsx:265
msgid "Follow"
msgstr ""

#. Relative time in seconds, as short as possible
#. placeholder {0}: seconds < 1 ? 1 : Math.floor(seconds)
#: src/components/relative-time.jsx:45
msgid "{0}s"
msgstr ""

#. Relative time in minutes, as short as possible
#. placeholder {0}: Math.floor(seconds / minute)
#: src/components/relative-time.jsx:50
msgid "{0}m"
msgstr ""

#. Relative time in hours, as short as possible
#. placeholder {0}: Math.floor(seconds / hour)
#: src/components/relative-time.jsx:55
msgid "{0}h"
msgstr ""

#: src/components/report-modal.jsx:30
msgid "Spam"
msgstr ""

#: src/components/report-modal.jsx:31
msgid "Malicious links, fake engagement, or repetitive replies"
msgstr ""

#: src/components/report-modal.jsx:34
msgid "Illegal"
msgstr ""

#: src/components/report-modal.jsx:35
msgid "Violates the law of your or the server's country"
msgstr ""

#: src/components/report-modal.jsx:38
msgid "Server rule violation"
msgstr ""

#: src/components/report-modal.jsx:39
msgid "Breaks specific server rules"
msgstr ""

#: src/components/report-modal.jsx:40
msgid "Violation"
msgstr ""

#: src/components/report-modal.jsx:43
msgid "Other"
msgstr ""

#: src/components/report-modal.jsx:44
msgid "Issue doesn't fit other categories"
msgstr ""

#: src/components/report-modal.jsx:111
msgid "Report Post"
msgstr ""

#: src/components/report-modal.jsx:111
msgid "Report @{username}"
msgstr ""

#: src/components/report-modal.jsx:147
msgid "Pending review"
msgstr ""

#: src/components/report-modal.jsx:189
msgid "Post reported"
msgstr ""

#: src/components/report-modal.jsx:189
msgid "Profile reported"
msgstr ""

#: src/components/report-modal.jsx:197
msgid "Unable to report post"
msgstr ""

#: src/components/report-modal.jsx:198
msgid "Unable to report profile"
msgstr ""

#: src/components/report-modal.jsx:206
msgid "What's the issue with this post?"
msgstr ""

#: src/components/report-modal.jsx:207
msgid "What's the issue with this profile?"
msgstr ""

#: src/components/report-modal.jsx:276
msgid "Additional info"
msgstr ""

#: src/components/report-modal.jsx:299
msgid "Forward to <0>{domain}</0>"
msgstr ""

#: src/components/report-modal.jsx:309
msgid "Send Report"
msgstr ""

#: src/components/report-modal.jsx:318
msgid "Muted {username}"
msgstr ""

#: src/components/report-modal.jsx:321
msgid "Unable to mute {username}"
msgstr ""

#: src/components/report-modal.jsx:326
msgid "Send Report <0>+ Mute profile</0>"
msgstr ""

#: src/components/report-modal.jsx:337
msgid "Blocked {username}"
msgstr ""

#: src/components/report-modal.jsx:340
msgid "Unable to block {username}"
msgstr ""

#: src/components/report-modal.jsx:345
msgid "Send Report <0>+ Block profile</0>"
msgstr ""

#: src/components/search-form.jsx:18
msgid "Posts with <0>{query}</0>"
msgstr ""

#: src/components/search-form.jsx:26
msgid "Accounts with <0>{query}</0>"
msgstr ""

#: src/components/search-form.jsx:37
msgid "Posts tagged with <0>{hashtag}</0>"
msgstr "Posts tagged with <0>{hashtag}</0>"

#: src/components/search-form.jsx:46
msgid "{query} <0>‒ accounts, hashtags & posts</0>"
msgstr ""

#: src/components/search-form.jsx:139
msgid "Look up <0>{query}</0>"
msgstr ""

#: src/components/search-form.jsx:365
#: src/pages/home.jsx:251
msgid "See all"
msgstr ""

#: src/components/shortcuts-settings.jsx:49
msgid "Home / Following"
msgstr ""

#: src/components/shortcuts-settings.jsx:52
msgid "Public (Local / Federated)"
msgstr ""

#: src/components/shortcuts-settings.jsx:54
msgid "Account"
msgstr ""

#: src/components/shortcuts-settings.jsx:57
msgid "Hashtag"
msgstr ""

#: src/components/shortcuts-settings.jsx:64
msgid "List ID"
msgstr ""

#: src/components/shortcuts-settings.jsx:71
msgid "Local only"
msgstr ""

#: src/components/shortcuts-settings.jsx:76
#: src/components/shortcuts-settings.jsx:85
#: src/components/shortcuts-settings.jsx:123
#: src/pages/login.jsx:203
msgid "Instance"
msgstr ""

#: src/components/shortcuts-settings.jsx:79
#: src/components/shortcuts-settings.jsx:88
#: src/components/shortcuts-settings.jsx:126
msgid "Optional, e.g. mastodon.social"
msgstr ""

#: src/components/shortcuts-settings.jsx:94
msgid "Search term"
msgstr ""

#: src/components/shortcuts-settings.jsx:97
msgid "Optional, unless for multi-column mode"
msgstr ""

#: src/components/shortcuts-settings.jsx:114
msgid "e.g. PixelArt (Max 5, space-separated)"
msgstr ""

#: src/components/shortcuts-settings.jsx:118
#: src/pages/hashtag.jsx:360
msgid "Media only"
msgstr ""

#: src/components/shortcuts-settings.jsx:236
#: src/components/shortcuts.jsx:220
msgid "Shortcuts"
msgstr ""

#: src/components/shortcuts-settings.jsx:244
msgid "beta"
msgstr ""

#: src/components/shortcuts-settings.jsx:250
msgid "Specify a list of shortcuts that'll appear as:"
msgstr ""

#: src/components/shortcuts-settings.jsx:256
msgid "Floating button"
msgstr ""

#: src/components/shortcuts-settings.jsx:261
msgid "Tab/Menu bar"
msgstr ""

#: src/components/shortcuts-settings.jsx:266
msgid "Multi-column"
msgstr ""

#: src/components/shortcuts-settings.jsx:333
msgid "Not available in current view mode"
msgstr ""

#: src/components/shortcuts-settings.jsx:352
#: src/pages/accounts.jsx:197
msgid "Move up"
msgstr ""

#: src/components/shortcuts-settings.jsx:368
#: src/pages/accounts.jsx:212
msgid "Move down"
msgstr ""

#: src/components/shortcuts-settings.jsx:380
#: src/components/status.jsx:1560
#: src/pages/list.jsx:195
msgid "Edit"
msgstr ""

#: src/components/shortcuts-settings.jsx:401
msgid "Add more than one shortcut/column to make this work."
msgstr ""

#: src/components/shortcuts-settings.jsx:412
msgid "No columns yet. Tap on the Add column button."
msgstr ""

#: src/components/shortcuts-settings.jsx:413
msgid "No shortcuts yet. Tap on the Add shortcut button."
msgstr ""

#: src/components/shortcuts-settings.jsx:416
msgid "Not sure what to add?<0/>Try adding <1>Home / Following and Notifications</1> first."
msgstr ""

#: src/components/shortcuts-settings.jsx:444
msgid "Max {SHORTCUTS_LIMIT} columns"
msgstr ""

#: src/components/shortcuts-settings.jsx:445
msgid "Max {SHORTCUTS_LIMIT} shortcuts"
msgstr ""

#: src/components/shortcuts-settings.jsx:459
#: src/pages/accounts.jsx:306
msgid "Import/export"
msgstr ""

#: src/components/shortcuts-settings.jsx:469
msgid "Add column…"
msgstr ""

#: src/components/shortcuts-settings.jsx:470
msgid "Add shortcut…"
msgstr ""

#: src/components/shortcuts-settings.jsx:517
msgid "Specific list is optional. For multi-column mode, list is required, else the column will not be shown."
msgstr ""

#: src/components/shortcuts-settings.jsx:518
msgid "For multi-column mode, search term is required, else the column will not be shown."
msgstr ""

#: src/components/shortcuts-settings.jsx:519
msgid "Multiple hashtags are supported. Space-separated."
msgstr ""

#: src/components/shortcuts-settings.jsx:588
msgid "Edit shortcut"
msgstr ""

#: src/components/shortcuts-settings.jsx:588
msgid "Add shortcut"
msgstr ""

#: src/components/shortcuts-settings.jsx:624
msgid "Timeline"
msgstr ""

#: src/components/shortcuts-settings.jsx:650
msgid "List"
msgstr ""

#: src/components/shortcuts-settings.jsx:790
msgid "Import/Export <0>Shortcuts</0>"
msgstr ""

#: src/components/shortcuts-settings.jsx:808
msgid "Paste shortcuts here"
msgstr ""

#: src/components/shortcuts-settings.jsx:845
msgid "Downloading saved shortcuts from instance server…"
msgstr ""

#: src/components/shortcuts-settings.jsx:874
msgid "Unable to download shortcuts"
msgstr ""

#: src/components/shortcuts-settings.jsx:877
msgid "Download shortcuts from instance server"
msgstr ""

#: src/components/shortcuts-settings.jsx:944
msgid "* Exists in current shortcuts"
msgstr ""

#: src/components/shortcuts-settings.jsx:949
msgid "List may not work if it's from a different account."
msgstr ""

#: src/components/shortcuts-settings.jsx:959
msgid "Invalid settings format"
msgstr ""

#: src/components/shortcuts-settings.jsx:967
msgid "Append to current shortcuts?"
msgstr ""

#: src/components/shortcuts-settings.jsx:970
msgid "Only shortcuts that don’t exist in current shortcuts will be appended."
msgstr ""

#: src/components/shortcuts-settings.jsx:992
msgid "No new shortcuts to import"
msgstr ""

#: src/components/shortcuts-settings.jsx:1007
msgid "Shortcuts imported. Exceeded max {SHORTCUTS_LIMIT}, so the rest are not imported."
msgstr ""

#: src/components/shortcuts-settings.jsx:1008
#: src/components/shortcuts-settings.jsx:1032
msgid "Shortcuts imported"
msgstr ""

#: src/components/shortcuts-settings.jsx:1018
msgid "Import & append…"
msgstr ""

#: src/components/shortcuts-settings.jsx:1026
msgid "Override current shortcuts?"
msgstr ""

#: src/components/shortcuts-settings.jsx:1027
msgid "Import shortcuts?"
msgstr ""

#: src/components/shortcuts-settings.jsx:1041
msgid "or override…"
msgstr ""

#: src/components/shortcuts-settings.jsx:1041
msgid "Import…"
msgstr ""

#: src/components/shortcuts-settings.jsx:1065
msgid "Shortcuts copied"
msgstr ""

#: src/components/shortcuts-settings.jsx:1068
msgid "Unable to copy shortcuts"
msgstr ""

#: src/components/shortcuts-settings.jsx:1120
msgid "Saving shortcuts to instance server…"
msgstr ""

#: src/components/shortcuts-settings.jsx:1127
msgid "Shortcuts saved"
msgstr ""

#: src/components/shortcuts-settings.jsx:1132
msgid "Unable to save shortcuts"
msgstr ""

#: src/components/shortcuts-settings.jsx:1135
msgid "Sync to instance server"
msgstr ""

#: src/components/shortcuts-settings.jsx:1150
msgid "Shortcut settings copied"
msgstr ""

#: src/components/shortcuts-settings.jsx:1153
msgid "Unable to copy shortcut settings"
msgstr ""

#: src/components/shortcuts-settings.jsx:1183
msgid "Share"
msgstr ""

#. placeholder {0}: shortcutsStr.length
#: src/components/shortcuts-settings.jsx:1189
msgid "{0, plural, one {# character} other {# characters}}"
msgstr ""

#: src/components/shortcuts-settings.jsx:1201
msgid "Raw Shortcuts JSON"
msgstr ""

#: src/components/shortcuts-settings.jsx:1214
msgid "Import/export settings from/to instance server (Very experimental)"
msgstr ""

#: src/components/status.jsx:289
msgid "Private posts cannot be quoted"
msgstr "Private posts cannot be quoted"

#: src/components/status.jsx:290
msgid "Request to quote"
msgstr "Request to quote"

#: src/components/status.jsx:291
msgid "Author will manually review"
msgstr "Author will manually review"

#: src/components/status.jsx:292
msgid "Only followers can quote this post"
msgstr "Only followers can quote this post"

#: src/components/status.jsx:293
msgid "You are not allowed to quote this post"
msgstr "You are not allowed to quote this post"

#: src/components/status.jsx:587
msgid "<0/> <1>boosted</1>"
msgstr "<0/> <1>boosted</1>"

#: src/components/status.jsx:693
msgid "Sorry, your current logged-in instance can't interact with this post from another instance."
msgstr ""

#. placeholder {0}: username || acct
#: src/components/status.jsx:882
msgid "Unliked @{0}'s post"
msgstr ""

#. placeholder {0}: username || acct
#: src/components/status.jsx:883
msgid "Liked @{0}'s post"
msgstr "Liked @{0}'s post"

#. placeholder {0}: username || acct
#: src/components/status.jsx:922
msgid "Unbookmarked @{0}'s post"
msgstr "Unbookmarked @{0}'s post"

#. placeholder {0}: username || acct
#: src/components/status.jsx:923
msgid "Bookmarked @{0}'s post"
msgstr "Bookmarked @{0}'s post"

#: src/components/status.jsx:1027
msgid "Some media have no descriptions."
msgstr ""

#. placeholder {0}: rtf.format(-statusMonthsAgo, 'month')
#: src/components/status.jsx:1034
msgid "Old post (<0>{0}</0>)"
msgstr ""

#: src/components/status.jsx:1055
msgid "Reply…"
msgstr "Reply…"

#: src/components/status.jsx:1064
#: src/components/status.jsx:1073
msgid "Reply all"
msgstr "Reply all"

#: src/components/status.jsx:1067
msgid "{mentionsCount, plural, other {# mentions}}"
msgstr "{mentionsCount, plural, other {# mentions}}"

#. placeholder {0}: mentionsCount - 1
#. placeholder {1}: username || acct
#: src/components/status.jsx:1076
msgid "{0, plural, other {<0>@{1}</0> first, # others below}}"
msgstr "{0, plural, other {<0>@{1}</0> first, # others below}}"

#. placeholder {0}: username || acct
#: src/components/status.jsx:1093
msgid "Only <0>@{0}</0>"
msgstr "Only <0>@{0}</0>"

#: src/components/status.jsx:1126
#: src/components/status.jsx:1203
#: src/components/status.jsx:2836
#: src/components/status.jsx:2889
msgid "Unboost"
msgstr ""

#: src/components/status.jsx:1165
#: src/components/status.jsx:2874
msgid "Quote with link"
msgstr "Quote with link"

#. placeholder {0}: username || acct
#: src/components/status.jsx:1182
#: src/components/status.jsx:1749
msgid "Unboosted @{0}'s post"
msgstr "Unboosted @{0}'s post"

#. placeholder {0}: username || acct
#: src/components/status.jsx:1183
#: src/components/status.jsx:1750
msgid "Boosted @{0}'s post"
msgstr "Boosted @{0}'s post"

#: src/components/status.jsx:1205
#: src/components/status.jsx:2888
msgid "Boost/Quote…"
msgstr "Boost/Quote…"

#: src/components/status.jsx:1206
#: src/components/status.jsx:2888
msgid "Boost…"
msgstr ""

#: src/components/status.jsx:1218
#: src/components/status.jsx:2079
#: src/components/status.jsx:2904
msgid "Unlike"
msgstr ""

#: src/components/status.jsx:1219
#: src/components/status.jsx:2079
#: src/components/status.jsx:2080
#: src/components/status.jsx:2904
#: src/components/status.jsx:2905
msgid "Like"
msgstr ""

#: src/components/status.jsx:1228
#: src/components/status.jsx:2916
msgid "Unbookmark"
msgstr ""

#: src/components/status.jsx:1263
msgid "View Quotes"
msgstr "View Quotes"

#: src/components/status.jsx:1330
msgid "Post text copied"
msgstr "Post text copied"

#: src/components/status.jsx:1333
msgid "Unable to copy post text"
msgstr "Unable to copy post text"

#: src/components/status.jsx:1339
msgid "Copy post text"
msgstr "Copy post text"

#. placeholder {0}: username || acct
#: src/components/status.jsx:1357
msgid "View post by <0>@{0}</0>"
msgstr ""

#: src/components/status.jsx:1378
msgid "Show Edit History"
msgstr ""

#: src/components/status.jsx:1381
msgid "Edited: {editedDateText}"
msgstr ""

#: src/components/status.jsx:1464
msgid "Conversation unmuted"
msgstr ""

#: src/components/status.jsx:1464
msgid "Conversation muted"
msgstr ""

#: src/components/status.jsx:1470
msgid "Unable to unmute conversation"
msgstr ""

#: src/components/status.jsx:1471
msgid "Unable to mute conversation"
msgstr ""

#: src/components/status.jsx:1480
msgid "Unmute conversation"
msgstr ""

#: src/components/status.jsx:1487
msgid "Mute conversation"
msgstr ""

#: src/components/status.jsx:1503
msgid "Post unpinned from profile"
msgstr ""

#: src/components/status.jsx:1504
msgid "Post pinned to profile"
msgstr ""

#: src/components/status.jsx:1509
msgid "Unable to unpin post"
msgstr ""

#: src/components/status.jsx:1509
msgid "Unable to pin post"
msgstr ""

#: src/components/status.jsx:1518
msgid "Unpin from profile"
msgstr ""

#: src/components/status.jsx:1525
msgid "Pin to profile"
msgstr ""

#: src/components/status.jsx:1538
#: src/pages/settings.jsx:332
msgid "Quote settings"
msgstr "Quote settings"

#: src/components/status.jsx:1571
msgid "Delete this post?"
msgstr ""

#: src/components/status.jsx:1587
msgid "Post deleted"
msgstr ""

#: src/components/status.jsx:1590
msgid "Unable to delete post"
msgstr ""

#. placeholder {0}: username || acct
#: src/components/status.jsx:1615
msgid "Remove my post from <0>@{0}</0>'s post?"
msgstr "Remove my post from <0>@{0}</0>'s post?"

#: src/components/status.jsx:1636
msgid "Quote removed"
msgstr "Quote removed"

#: src/components/status.jsx:1640
msgid "Unable to remove quote"
msgstr "Unable to remove quote"

#: src/components/status.jsx:1646
msgid "Remove quote…"
msgstr "Remove quote…"

#: src/components/status.jsx:1660
msgid "Report post…"
msgstr ""

#: src/components/status.jsx:2080
#: src/components/status.jsx:2116
#: src/components/status.jsx:2905
msgid "Liked"
msgstr ""

#: src/components/status.jsx:2113
#: src/components/status.jsx:2891
msgid "Boosted"
msgstr ""

#: src/components/status.jsx:2123
#: src/components/status.jsx:2917
msgid "Bookmarked"
msgstr ""

#: src/components/status.jsx:2127
msgid "Pinned"
msgstr ""

#: src/components/status.jsx:2184
#: src/components/status.jsx:2674
msgid "Deleted"
msgstr ""

#: src/components/status.jsx:2222
#: src/components/status.jsx:2290
msgid "{repliesCount, plural, one {# reply} other {# replies}}"
msgstr ""

#: src/components/status.jsx:2396
#: src/components/status.jsx:2458
#: src/components/status.jsx:2564
msgid "Show less"
msgstr ""

#: src/components/status.jsx:2396
#: src/components/status.jsx:2458
msgid "Show content"
msgstr ""

#. placeholder {0}: filterInfo.titlesStr
#. placeholder {0}: filterInfo?.titlesStr
#: src/components/status.jsx:2560
#: src/pages/catchup.jsx:2021
msgid "Filtered: {0}"
msgstr "Filtered: {0}"

#: src/components/status.jsx:2564
msgid "Show media"
msgstr ""

#: src/components/status.jsx:2709
msgid "Edited"
msgstr ""

#: src/components/status.jsx:2795
#: src/components/status.jsx:2807
msgid "Comments"
msgstr ""

#: src/components/status.jsx:3065
msgid "Post hidden by your filters"
msgstr "Post hidden by your filters"

#: src/components/status.jsx:3066
msgid "Post pending"
msgstr "Post pending"

#: src/components/status.jsx:3067
#: src/components/status.jsx:3068
#: src/components/status.jsx:3069
msgid "Post unavailable"
msgstr "Post unavailable"

#: src/components/status.jsx:3070
msgid "Post removed by author"
msgstr "Post removed by author"

#: src/components/status.jsx:3071
msgid "Post hidden because you've blocked @{name}."
msgstr "Post hidden because you've blocked @{name}."

#: src/components/status.jsx:3073
msgid "Post hidden because you've blocked {domain}."
msgstr "Post hidden because you've blocked {domain}."

#: src/components/status.jsx:3074
msgid "Post hidden because you've muted @{name}."
msgstr "Post hidden because you've muted @{name}."

#: src/components/status.jsx:3145
msgid "Show anyway"
msgstr "Show anyway"

#: src/components/status.jsx:3244
msgid "Edit History"
msgstr ""

#: src/components/status.jsx:3248
msgid "Failed to load history"
msgstr ""

#: src/components/status.jsx:3253
msgid "Loading…"
msgstr ""

#. [Name] [Visibility icon] boosted
#: src/components/status.jsx:3385
msgid "<0/> <1/> boosted"
msgstr "<0/> <1/> boosted"

#: src/components/thread-badge.jsx:22
#: src/components/thread-badge.jsx:37
#: src/components/thread-badge.jsx:52
#: src/pages/catchup.jsx:2039
msgid "Thread"
msgstr ""

#: src/components/thread-badge.jsx:28
msgid "Thread {index}/{total}"
msgstr "Thread {index}/{total}"

#. X is the unspecified total number of posts in a thread
#: src/components/thread-badge.jsx:32
msgid "Thread {index}/X"
msgstr "Thread {index}/X"

#. index/total posts in a thread
#: src/components/thread-badge.jsx:41
msgid "{index}/{total}"
msgstr "{index}/{total}"

#. X is the unspecified total number of posts in a thread
#: src/components/thread-badge.jsx:46
msgid "{index}/X"
msgstr "{index}/X"

#: src/components/timeline.jsx:480
#: src/pages/settings.jsx:1244
msgid "New posts"
msgstr ""

#: src/components/timeline.jsx:581
#: src/pages/home.jsx:228
#: src/pages/notifications.jsx:893
#: src/pages/status.jsx:1153
#: src/pages/status.jsx:1626
msgid "Try again"
msgstr ""

#. placeholder {0}: fItems.length
#: src/components/timeline.jsx:616
msgid "{0, plural, one {# Boost} other {# Boosts}}"
msgstr "{0, plural, one {# Boost} other {# Boosts}}"

#: src/components/timeline.jsx:621
msgid "Pinned posts"
msgstr "Pinned posts"

#. placeholder {0}: filterInfo.titlesStr
#: src/components/timeline.jsx:974
msgid "<0>Filtered</0>: <1>{0}</1>"
msgstr ""

#: src/components/translated-bio-sheet.jsx:26
msgid "Translated Bio"
msgstr ""

#: src/components/translation-block.jsx:226
msgid "Auto-translated from {sourceLangText}"
msgstr ""

#: src/components/translation-block.jsx:265
msgid "Translating…"
msgstr ""

#: src/components/translation-block.jsx:268
msgid "Translate from {sourceLangText} (auto-detected)"
msgstr ""

#: src/components/translation-block.jsx:269
msgid "Translate from {sourceLangText}"
msgstr ""

#. placeholder {0}: detectedLang ?? '…'
#: src/components/translation-block.jsx:297
msgid "Auto ({0})"
msgstr ""

#: src/components/translation-block.jsx:310
msgid "Failed to translate"
msgstr ""

#: src/compose.jsx:37
msgid "Editing source status"
msgstr ""

#. placeholder {0}: replyToStatus.account?.acct || replyToStatus.account?.username
#: src/compose.jsx:39
msgid "Replying to @{0}"
msgstr ""

#: src/compose.jsx:67
msgid "You may close this page now."
msgstr ""

#: src/compose.jsx:75
msgid "Close window"
msgstr ""

#: src/compose.jsx:91
msgid "Login required."
msgstr "Login required."

#: src/compose.jsx:95
#: src/pages/annual-report.jsx:186
#: src/pages/http-route.jsx:91
#: src/pages/login.jsx:280
msgid "Go home"
msgstr ""

#: src/pages/account-statuses.jsx:242
msgid "Account posts"
msgstr ""

#: src/pages/account-statuses.jsx:249
msgid "{accountDisplay} (+ Replies)"
msgstr ""

#: src/pages/account-statuses.jsx:251
msgid "{accountDisplay} (- Boosts)"
msgstr ""

#: src/pages/account-statuses.jsx:253
msgid "{accountDisplay} (#{tagged})"
msgstr ""

#: src/pages/account-statuses.jsx:255
msgid "{accountDisplay} (Media)"
msgstr ""

#: src/pages/account-statuses.jsx:261
msgid "{accountDisplay} ({monthYear})"
msgstr ""

#: src/pages/account-statuses.jsx:332
msgid "Clear filters"
msgstr ""

#: src/pages/account-statuses.jsx:349
msgid "Showing post with replies"
msgstr ""

#: src/pages/account-statuses.jsx:354
msgid "+ Replies"
msgstr ""

#: src/pages/account-statuses.jsx:360
msgid "Showing posts without boosts"
msgstr ""

#: src/pages/account-statuses.jsx:365
msgid "- Boosts"
msgstr ""

#: src/pages/account-statuses.jsx:371
msgid "Showing posts with media"
msgstr ""

#. placeholder {0}: tag.name
#: src/pages/account-statuses.jsx:388
msgid "Showing posts tagged with #{0}"
msgstr ""

#. placeholder {0}: date.toLocaleString(i18n.locale, { month: 'long', year: 'numeric', })
#: src/pages/account-statuses.jsx:427
msgid "Showing posts in {0}"
msgstr "Showing posts in {0}"

#: src/pages/account-statuses.jsx:521
msgid "Nothing to see here yet."
msgstr ""

#: src/pages/account-statuses.jsx:522
#: src/pages/public.jsx:99
#: src/pages/trending.jsx:452
msgid "Unable to load posts"
msgstr ""

#: src/pages/account-statuses.jsx:563
#: src/pages/account-statuses.jsx:593
msgid "Unable to fetch account info"
msgstr ""

#. placeholder {0}: accountInstance ? ( <> {' '} (<b>{punycode.toUnicode(accountInstance)}</b>) </> ) : null
#: src/pages/account-statuses.jsx:570
msgid "Switch to account's instance {0}"
msgstr ""

#: src/pages/account-statuses.jsx:600
msgid "Switch to my instance (<0>{currentInstance}</0>)"
msgstr ""

#: src/pages/account-statuses.jsx:673
msgid "Month"
msgstr ""

#: src/pages/accounts.jsx:65
msgid "Current"
msgstr ""

#: src/pages/accounts.jsx:113
msgid "Logged out"
msgstr "Logged out"

#: src/pages/accounts.jsx:119
msgid "Default"
msgstr ""

#: src/pages/accounts.jsx:141
msgid "Switch to this account"
msgstr "Switch to this account"

#: src/pages/accounts.jsx:150
msgid "Switch in new tab/window"
msgstr "Switch in new tab/window"

#: src/pages/accounts.jsx:164
msgid "View profile…"
msgstr ""

#: src/pages/accounts.jsx:182
msgid "Set as default"
msgstr ""

#. placeholder {0}: account.info.acct
#: src/pages/accounts.jsx:224
msgid "Log out <0>@{0}</0>?"
msgstr ""

#: src/pages/accounts.jsx:262
msgid "Log out…"
msgstr ""

#. placeholder {0}: niceDateTime(account.createdAt)
#: src/pages/accounts.jsx:269
msgid "Connected on {0} (<0/>)"
msgstr "Connected on {0} (<0/>)"

#: src/pages/accounts.jsx:286
msgid "Add an existing account"
msgstr ""

#: src/pages/accounts.jsx:293
msgid "Note: <0>Default</0> account will always be used for first load. Switched accounts will persist during the session."
msgstr ""

#: src/pages/bookmarks.jsx:28
msgid "No bookmarks yet. Go bookmark something!"
msgstr "No bookmarks yet. Go bookmark something!"

#: src/pages/bookmarks.jsx:29
msgid "Unable to load bookmarks."
msgstr ""

#: src/pages/catchup.jsx:57
msgid "last 1 hour"
msgstr ""

#: src/pages/catchup.jsx:58
msgid "last 2 hours"
msgstr ""

#: src/pages/catchup.jsx:59
msgid "last 3 hours"
msgstr ""

#: src/pages/catchup.jsx:60
msgid "last 4 hours"
msgstr ""

#: src/pages/catchup.jsx:61
msgid "last 5 hours"
msgstr ""

#: src/pages/catchup.jsx:62
msgid "last 6 hours"
msgstr ""

#: src/pages/catchup.jsx:63
msgid "last 7 hours"
msgstr ""

#: src/pages/catchup.jsx:64
msgid "last 8 hours"
msgstr ""

#: src/pages/catchup.jsx:65
msgid "last 9 hours"
msgstr ""

#: src/pages/catchup.jsx:66
msgid "last 10 hours"
msgstr ""

#: src/pages/catchup.jsx:67
msgid "last 11 hours"
msgstr ""

#: src/pages/catchup.jsx:68
msgid "last 12 hours"
msgstr ""

#: src/pages/catchup.jsx:69
msgid "beyond 12 hours"
msgstr ""

#: src/pages/catchup.jsx:77
msgid "Followed tags"
msgstr ""

#: src/pages/catchup.jsx:78
msgid "Groups"
msgstr ""

#: src/pages/catchup.jsx:713
msgid "Showing {selectedFilterCategory, select, all {all posts} original {original posts} replies {replies} boosts {boosts} quotes {quotes} followedTags {followed tags} groups {groups} filtered {filtered posts}}, {sortBy, select, createdAt {{sortOrder, select, asc {oldest} desc {latest}}} reblogsCount {{sortOrder, select, asc {fewest boosts} desc {most boosts}}} favouritesCount {{sortOrder, select, asc {fewest likes} desc {most likes}}} repliesCount {{sortOrder, select, asc {fewest replies} desc {most replies}}} density {{sortOrder, select, asc {least dense} desc {most dense}}}} first{groupBy, select, account {, grouped by authors} other {}}"
msgstr "Showing {selectedFilterCategory, select, all {all posts} original {original posts} replies {replies} boosts {boosts} quotes {quotes} followedTags {followed tags} groups {groups} filtered {filtered posts}}, {sortBy, select, createdAt {{sortOrder, select, asc {oldest} desc {latest}}} reblogsCount {{sortOrder, select, asc {fewest boosts} desc {most boosts}}} favouritesCount {{sortOrder, select, asc {fewest likes} desc {most likes}}} repliesCount {{sortOrder, select, asc {fewest replies} desc {most replies}}} density {{sortOrder, select, asc {least dense} desc {most dense}}}} first{groupBy, select, account {, grouped by authors} other {}}"

#: src/pages/catchup.jsx:1006
#: src/pages/catchup.jsx:1030
msgid "Catch-up <0>beta</0>"
msgstr ""

#: src/pages/catchup.jsx:1020
#: src/pages/catchup.jsx:1705
msgid "Help"
msgstr ""

#: src/pages/catchup.jsx:1036
msgid "What is this?"
msgstr ""

#: src/pages/catchup.jsx:1039
msgid "Catch-up is a separate timeline for your followings, offering a high-level view at a glance, with a simple, email-inspired interface to effortlessly sort and filter through posts."
msgstr ""

#: src/pages/catchup.jsx:1050
msgid "Preview of Catch-up UI"
msgstr "Preview of Catch-up UI"

#: src/pages/catchup.jsx:1059
msgid "Let's catch up"
msgstr ""

#: src/pages/catchup.jsx:1064
msgid "Let's catch up on the posts from your followings."
msgstr ""

#: src/pages/catchup.jsx:1068
msgid "Show me all posts from…"
msgstr ""

#: src/pages/catchup.jsx:1091
msgid "until the max"
msgstr "until the max"

#: src/pages/catchup.jsx:1121
msgid "Catch up"
msgstr ""

#: src/pages/catchup.jsx:1127
msgid "Overlaps with your last catch-up"
msgstr ""

#. placeholder {0}: dtf.format(new Date(lastCatchupEndAt))
#: src/pages/catchup.jsx:1139
msgid "Until the last catch-up ({0})"
msgstr ""

#: src/pages/catchup.jsx:1148
msgid "Note: your instance might only show a maximum of 800 posts in the Home timeline regardless of the time range. Could be less or more."
msgstr ""

#: src/pages/catchup.jsx:1158
msgid "Previously…"
msgstr ""

#. placeholder {0}: pc.count
#: src/pages/catchup.jsx:1176
msgid "{0, plural, one {# post} other {# posts}}"
msgstr ""

#: src/pages/catchup.jsx:1186
msgid "Remove this catch-up?"
msgstr "Remove this catch-up?"

#. placeholder {0}: pc.id
#: src/pages/catchup.jsx:1189
msgid "Removing Catch-up {0}"
msgstr "Removing Catch-up {0}"

#. placeholder {0}: pc.id
#: src/pages/catchup.jsx:1193
msgid "Catch-up {0} removed"
msgstr "Catch-up {0} removed"

#: src/pages/catchup.jsx:1207
msgid "Note: Only max 3 will be stored. The rest will be automatically removed."
msgstr ""

#: src/pages/catchup.jsx:1222
msgid "Fetching posts…"
msgstr ""

#: src/pages/catchup.jsx:1225
msgid "This might take a while."
msgstr ""

#: src/pages/catchup.jsx:1260
msgid "Reset filters"
msgstr ""

#: src/pages/catchup.jsx:1268
#: src/pages/catchup.jsx:1711
msgid "Top links"
msgstr ""

#. placeholder {0}: sharers.map((s) => { const { avatarStatic, displayName } = s; return ( <button type="button" class="plain" style={{ padding: 0, }} onClick={(e) => { e.preventDefault(); e.stopPropagation(); // Reset and filter to author const { id } = s; setSelectedAuthor(id); setSelectedFilterCategory('all'); }} > <Avatar url={avatarStatic} size="s" alt={displayName} /> </button> ); })
#: src/pages/catchup.jsx:1381
msgid "Shared by {0}"
msgstr ""

#: src/pages/catchup.jsx:1436
#: src/pages/mentions.jsx:154
#: src/pages/search.jsx:330
msgid "All"
msgstr ""

#. placeholder {0}: authorCountsList.length
#: src/pages/catchup.jsx:1521
msgid "{0, plural, one {# author} other {# authors}}"
msgstr ""

#: src/pages/catchup.jsx:1533
msgid "Sort"
msgstr ""

#: src/pages/catchup.jsx:1563
msgid "Date"
msgstr "Date"

#: src/pages/catchup.jsx:1568
msgid "Density"
msgstr "Density"

#. js-lingui-explicit-id
#: src/pages/catchup.jsx:1591
msgid "group.filter"
msgstr "Group"

#: src/pages/catchup.jsx:1606
msgid "Authors"
msgstr "Authors"

#: src/pages/catchup.jsx:1607
msgid "None"
msgstr "None"

#: src/pages/catchup.jsx:1623
msgid "Show all authors"
msgstr ""

#: src/pages/catchup.jsx:1674
msgid "You don't have to read everything."
msgstr "You don't have to read everything."

#: src/pages/catchup.jsx:1675
msgid "That's all."
msgstr "That's all."

#: src/pages/catchup.jsx:1683
msgid "Back to top"
msgstr ""

#: src/pages/catchup.jsx:1714
msgid "Links shared by followings, sorted by shared counts, boosts and likes."
msgstr ""

#: src/pages/catchup.jsx:1720
msgid "Sort: Density"
msgstr ""

#: src/pages/catchup.jsx:1723
msgid "Posts are sorted by information density or depth. Shorter posts are \"lighter\" while longer posts are \"heavier\". Posts with photos are \"heavier\" than posts without photos."
msgstr ""

#: src/pages/catchup.jsx:1730
msgid "Group: Authors"
msgstr ""

#: src/pages/catchup.jsx:1733
msgid "Posts are grouped by authors, sorted by posts count per author."
msgstr ""

#: src/pages/catchup.jsx:1780
msgid "Next author"
msgstr ""

#: src/pages/catchup.jsx:1788
msgid "Previous author"
msgstr ""

#: src/pages/catchup.jsx:1804
msgid "Scroll to top"
msgstr ""

#: src/pages/favourites.jsx:28
msgid "No likes yet. Go like something!"
msgstr "No likes yet. Go like something!"

#: src/pages/favourites.jsx:29
msgid "Unable to load likes."
msgstr ""

#: src/pages/filters.jsx:23
msgid "Home and lists"
msgstr ""

#: src/pages/filters.jsx:25
msgid "Public timelines"
msgstr ""

#: src/pages/filters.jsx:26
msgid "Conversations"
msgstr ""

#: src/pages/filters.jsx:27
msgid "Profiles"
msgstr ""

#: src/pages/filters.jsx:42
msgid "Never"
msgstr ""

#: src/pages/filters.jsx:104
#: src/pages/filters.jsx:229
msgid "New filter"
msgstr ""

#. placeholder {0}: filters.length
#: src/pages/filters.jsx:152
msgid "{0, plural, one {# filter} other {# filters}}"
msgstr ""

#: src/pages/filters.jsx:167
msgid "Unable to load filters."
msgstr ""

#: src/pages/filters.jsx:171
msgid "No filters yet."
msgstr ""

#: src/pages/filters.jsx:178
msgid "Add filter"
msgstr ""

#: src/pages/filters.jsx:229
msgid "Edit filter"
msgstr ""

#: src/pages/filters.jsx:346
msgid "Unable to edit filter"
msgstr ""

#: src/pages/filters.jsx:347
msgid "Unable to create filter"
msgstr ""

#: src/pages/filters.jsx:356
msgid "Title"
msgstr ""

#: src/pages/filters.jsx:397
msgid "Whole word"
msgstr ""

#: src/pages/filters.jsx:423
msgid "No keywords. Add one."
msgstr ""

#: src/pages/filters.jsx:450
msgid "Add keyword"
msgstr ""

#. placeholder {0}: filteredEditKeywords.length
#: src/pages/filters.jsx:454
msgid "{0, plural, one {# keyword} other {# keywords}}"
msgstr ""

#: src/pages/filters.jsx:467
msgid "Filter from…"
msgstr ""

#: src/pages/filters.jsx:493
msgid "* Not implemented yet"
msgstr ""

#: src/pages/filters.jsx:499
msgid "Status: <0><1/></0>"
msgstr ""

#: src/pages/filters.jsx:508
msgid "Change expiry"
msgstr ""

#: src/pages/filters.jsx:508
msgid "Expiry"
msgstr ""

#: src/pages/filters.jsx:527
msgid "Filtered post will be…"
msgstr ""

#: src/pages/filters.jsx:538
msgid "obscured (media only)"
msgstr "obscured (media only)"

#: src/pages/filters.jsx:552
msgid "minimized"
msgstr ""

#: src/pages/filters.jsx:562
msgid "hidden"
msgstr ""

#: src/pages/filters.jsx:579
msgid "Delete this filter?"
msgstr ""

#: src/pages/filters.jsx:592
msgid "Unable to delete filter."
msgstr ""

#: src/pages/filters.jsx:625
msgid "Expired"
msgstr ""

#: src/pages/filters.jsx:627
msgid "Expiring <0/>"
msgstr ""

#: src/pages/filters.jsx:631
msgid "Never expires"
msgstr ""

#. placeholder {0}: followedHashtags.length
#: src/pages/followed-hashtags.jsx:71
msgid "{0, plural, one {# hashtag} other {# hashtags}}"
msgstr ""

#: src/pages/followed-hashtags.jsx:86
msgid "Unable to load followed hashtags."
msgstr ""

#: src/pages/followed-hashtags.jsx:90
msgid "No hashtags followed yet."
msgstr ""

#: src/pages/following.jsx:158
msgid "Nothing to see here."
msgstr ""

#: src/pages/following.jsx:159
#: src/pages/list.jsx:109
msgid "Unable to load posts."
msgstr ""

#: src/pages/hashtag.jsx:56
msgid "{hashtagTitle} (Media only) on {instance}"
msgstr ""

#: src/pages/hashtag.jsx:57
msgid "{hashtagTitle} on {instance}"
msgstr ""

#: src/pages/hashtag.jsx:59
msgid "{hashtagTitle} (Media only)"
msgstr ""

#: src/pages/hashtag.jsx:60
msgid "{hashtagTitle}"
msgstr ""

#: src/pages/hashtag.jsx:185
msgid "No one has posted anything with this tag yet."
msgstr ""

#: src/pages/hashtag.jsx:186
msgid "Unable to load posts with this tag"
msgstr ""

#: src/pages/hashtag.jsx:212
msgid "Unfollow #{hashtag}?"
msgstr "Unfollow #{hashtag}?"

#: src/pages/hashtag.jsx:227
msgid "Unfollowed #{hashtag}"
msgstr ""

#: src/pages/hashtag.jsx:242
msgid "Followed #{hashtag}"
msgstr ""

#: src/pages/hashtag.jsx:258
msgid "Following…"
msgstr ""

#: src/pages/hashtag.jsx:287
msgid "Unfeatured on profile"
msgstr ""

#: src/pages/hashtag.jsx:301
msgid "Unable to unfeature on profile"
msgstr ""

#: src/pages/hashtag.jsx:310
#: src/pages/hashtag.jsx:326
msgid "Featured on profile"
msgstr ""

#: src/pages/hashtag.jsx:398
msgid "{TOTAL_TAGS_LIMIT, plural, other {Max # tags}}"
msgstr ""

#: src/pages/hashtag.jsx:401
msgid "Add hashtag"
msgstr ""

#: src/pages/hashtag.jsx:433
msgid "Remove hashtag"
msgstr ""

#: src/pages/hashtag.jsx:447
msgid "{SHORTCUTS_LIMIT, plural, one {Max # shortcut reached. Unable to add shortcut.} other {Max # shortcuts reached. Unable to add shortcut.}}"
msgstr ""

#: src/pages/hashtag.jsx:476
msgid "This shortcut already exists"
msgstr ""

#: src/pages/hashtag.jsx:479
msgid "Hashtag shortcut added"
msgstr ""

#: src/pages/hashtag.jsx:485
msgid "Add to Shortcuts"
msgstr ""

#: src/pages/hashtag.jsx:491
#: src/pages/public.jsx:141
#: src/pages/trending.jsx:481
msgid "Enter a new instance e.g. \"mastodon.social\""
msgstr ""

#: src/pages/hashtag.jsx:494
#: src/pages/public.jsx:144
#: src/pages/trending.jsx:484
msgid "Invalid instance"
msgstr ""

#: src/pages/hashtag.jsx:508
#: src/pages/public.jsx:158
#: src/pages/trending.jsx:496
msgid "Go to another instance…"
msgstr ""

#: src/pages/hashtag.jsx:521
#: src/pages/public.jsx:171
#: src/pages/trending.jsx:507
msgid "Go to my instance (<0>{currentInstance}</0>)"
msgstr ""

#: src/pages/home.jsx:224
msgid "Unable to fetch notifications."
msgstr ""

#: src/pages/home.jsx:245
msgid "<0>New</0> <1>Follow Requests</1>"
msgstr ""

#: src/pages/http-route.jsx:68
msgid "Resolving…"
msgstr ""

#: src/pages/http-route.jsx:79
msgid "Unable to resolve URL"
msgstr ""

#: src/pages/list.jsx:108
msgid "Nothing yet."
msgstr ""

#: src/pages/list.jsx:201
#: src/pages/list.jsx:307
msgid "Manage members"
msgstr ""

#. placeholder {0}: account.username
#: src/pages/list.jsx:342
msgid "Remove <0>@{0}</0> from list?"
msgstr ""

#: src/pages/list.jsx:388
msgid "Remove…"
msgstr ""

#. placeholder {0}: lists.length
#: src/pages/lists.jsx:115
msgid "{0, plural, one {# list} other {# lists}}"
msgstr ""

#: src/pages/lists.jsx:135
msgid "No lists yet."
msgstr ""

#: src/pages/login.jsx:122
#: src/pages/login.jsx:132
msgid "Failed to register application"
msgstr "Failed to register application"

#: src/pages/login.jsx:218
msgid "instance domain"
msgstr "instance domain"

#: src/pages/login.jsx:242
msgid "e.g. “mastodon.social”"
msgstr ""

#: src/pages/login.jsx:253
msgid "Failed to log in. Please try again or try another instance."
msgstr ""

#: src/pages/login.jsx:265
msgid "Continue with {selectedInstanceText}"
msgstr ""

#: src/pages/login.jsx:266
msgid "Continue"
msgstr ""

#: src/pages/login.jsx:274
msgid "Don't have an account? Create one!"
msgstr ""

#: src/pages/mentions.jsx:21
msgid "Private mentions"
msgstr ""

#: src/pages/mentions.jsx:166
msgid "Private"
msgstr ""

#: src/pages/mentions.jsx:176
msgid "No one mentioned you :("
msgstr ""

#: src/pages/mentions.jsx:177
msgid "Unable to load mentions."
msgstr ""

#: src/pages/notifications.jsx:102
msgid "You don't follow"
msgstr ""

#: src/pages/notifications.jsx:103
msgid "Who don't follow you"
msgstr ""

#: src/pages/notifications.jsx:104
msgid "With a new account"
msgstr ""

#: src/pages/notifications.jsx:105
msgid "Who unsolicitedly private mention you"
msgstr ""

#: src/pages/notifications.jsx:106
msgid "Who are limited by server moderators"
msgstr ""

#: src/pages/notifications.jsx:600
#: src/pages/notifications.jsx:941
msgid "Notifications settings"
msgstr ""

#: src/pages/notifications.jsx:618
msgid "New notifications"
msgstr ""

#. placeholder {0}: announcements.length
#: src/pages/notifications.jsx:629
msgid "{0, plural, one {Announcement} other {Announcements}}"
msgstr ""

#: src/pages/notifications.jsx:676
#: src/pages/settings.jsx:1232
msgid "Follow requests"
msgstr ""

#. placeholder {0}: followRequests.length
#: src/pages/notifications.jsx:681
msgid "{0, plural, one {# follow request} other {# follow requests}}"
msgstr ""

#. placeholder {0}: notificationsPolicy.summary.pendingRequestsCount
#: src/pages/notifications.jsx:736
msgid "{0, plural, one {Filtered notifications from # person} other {Filtered notifications from # people}}"
msgstr ""

#: src/pages/notifications.jsx:809
msgid "Only mentions"
msgstr ""

#: src/pages/notifications.jsx:813
msgid "Today"
msgstr ""

#: src/pages/notifications.jsx:818
msgid "You're all caught up."
msgstr ""

#: src/pages/notifications.jsx:841
msgid "Yesterday"
msgstr ""

#: src/pages/notifications.jsx:889
msgid "Unable to load notifications"
msgstr ""

#: src/pages/notifications.jsx:968
msgid "Notifications settings updated"
msgstr ""

#: src/pages/notifications.jsx:976
msgid "Filter out notifications from people:"
msgstr ""

#: src/pages/notifications.jsx:990
msgid "Filter"
msgstr ""

#: src/pages/notifications.jsx:993
msgid "Ignore"
msgstr ""

#. placeholder {0}: niceDateTime(updatedAtDate)
#: src/pages/notifications.jsx:1066
msgid "Updated <0>{0}</0>"
msgstr ""

#. placeholder {0}: account.username
#: src/pages/notifications.jsx:1134
msgid "View notifications from <0>@{0}</0>"
msgstr ""

#. placeholder {0}: account.username
#: src/pages/notifications.jsx:1155
msgid "Notifications from <0>@{0}</0>"
msgstr ""

#. placeholder {0}: request.account.username
#: src/pages/notifications.jsx:1223
msgid "Notifications from @{0} will not be filtered from now on."
msgstr ""

#: src/pages/notifications.jsx:1228
msgid "Unable to accept notification request"
msgstr ""

#: src/pages/notifications.jsx:1233
msgid "Allow"
msgstr ""

#. placeholder {0}: request.account.username
#: src/pages/notifications.jsx:1253
msgid "Notifications from @{0} will not show up in Filtered notifications from now on."
msgstr "Notifications from @{0} will not show up in Filtered notifications from now on."

#: src/pages/notifications.jsx:1258
msgid "Unable to dismiss notification request"
msgstr ""

#: src/pages/notifications.jsx:1263
msgid "Dismiss"
msgstr ""

#: src/pages/notifications.jsx:1278
msgid "Dismissed"
msgstr ""

#: src/pages/public.jsx:28
msgid "Local timeline ({instance})"
msgstr ""

#: src/pages/public.jsx:29
msgid "Federated timeline ({instance})"
msgstr ""

#: src/pages/public.jsx:92
msgid "Local timeline"
msgstr ""

#: src/pages/public.jsx:92
msgid "Federated timeline"
msgstr ""

#: src/pages/public.jsx:98
msgid "No one has posted anything yet."
msgstr ""

#: src/pages/public.jsx:125
msgid "Switch to Federated"
msgstr "Switch to Federated"

#: src/pages/public.jsx:132
msgid "Switch to Local"
msgstr "Switch to Local"

#: src/pages/scheduled-posts.jsx:110
msgid "No scheduled posts."
msgstr "No scheduled posts."

#. Scheduled [in 1 day] ([Thu, Feb 27, 6:30:00 PM])
#. placeholder {0}: niceDateTime(scheduledAt, { formatOpts: { weekday: 'short', second: 'numeric', }, })
#: src/pages/scheduled-posts.jsx:210
msgid "Scheduled <0><1/></0> <2>({0})</2>"
msgstr "Scheduled <0><1/></0> <2>({0})</2>"

#. Scheduled [in 1 day]
#: src/pages/scheduled-posts.jsx:292
msgid "Scheduled <0><1/></0>"
msgstr "Scheduled <0><1/></0>"

#: src/pages/scheduled-posts.jsx:337
msgid "Scheduled post rescheduled"
msgstr "Scheduled post rescheduled"

#: src/pages/scheduled-posts.jsx:344
msgid "Failed to reschedule post"
msgstr "Failed to reschedule post"

#: src/pages/scheduled-posts.jsx:367
msgid "Reschedule"
msgstr "Reschedule"

#: src/pages/scheduled-posts.jsx:373
msgid "Delete scheduled post?"
msgstr "Delete scheduled post?"

#: src/pages/scheduled-posts.jsx:381
msgid "Scheduled post deleted"
msgstr "Scheduled post deleted"

#: src/pages/scheduled-posts.jsx:388
msgid "Failed to delete scheduled post"
msgstr "Failed to delete scheduled post"

#: src/pages/search.jsx:51
msgid "Search: {q} (Posts)"
msgstr ""

#: src/pages/search.jsx:54
msgid "Search: {q} (Accounts)"
msgstr ""

#: src/pages/search.jsx:57
msgid "Search: {q} (Hashtags)"
msgstr ""

#: src/pages/search.jsx:60
msgid "Search: {q}"
msgstr ""

#: src/pages/search.jsx:340
#: src/pages/search.jsx:422
msgid "Hashtags"
msgstr ""

#: src/pages/search.jsx:372
#: src/pages/search.jsx:426
#: src/pages/search.jsx:496
msgid "See more"
msgstr ""

#: src/pages/search.jsx:398
msgid "See more accounts"
msgstr ""

#: src/pages/search.jsx:412
msgid "No accounts found."
msgstr ""

#: src/pages/search.jsx:468
msgid "See more hashtags"
msgstr ""

#: src/pages/search.jsx:482
msgid "No hashtags found."
msgstr ""

#: src/pages/search.jsx:526
msgid "See more posts"
msgstr ""

#: src/pages/search.jsx:540
msgid "No posts found."
msgstr ""

#: src/pages/search.jsx:585
msgid "Enter your search term or paste a URL above to get started."
msgstr ""

#: src/pages/settings.jsx:98
msgid "Settings"
msgstr ""

#: src/pages/settings.jsx:107
msgid "Appearance"
msgstr ""

#: src/pages/settings.jsx:183
msgid "Light"
msgstr ""

#: src/pages/settings.jsx:194
msgid "Dark"
msgstr ""

#: src/pages/settings.jsx:207
msgid "Auto"
msgstr ""

#: src/pages/settings.jsx:217
msgid "Text size"
msgstr ""

#. Preview of one character, in largest size
#. Preview of one character, in smallest size
#: src/pages/settings.jsx:222
#: src/pages/settings.jsx:247
msgid "A"
msgstr ""

#: src/pages/settings.jsx:261
msgid "Display language"
msgstr ""

#: src/pages/settings.jsx:269
msgid "Volunteer translations"
msgstr "Volunteer translations"

#: src/pages/settings.jsx:280
msgid "Posting"
msgstr ""

#: src/pages/settings.jsx:286
msgid "Default visibility"
msgstr ""

#: src/pages/settings.jsx:287
#: src/pages/settings.jsx:333
#: src/pages/settings.jsx:381
msgid "Synced"
msgstr ""

#: src/pages/settings.jsx:310
msgid "Default visibility updated"
msgstr "Default visibility updated"

#: src/pages/settings.jsx:312
msgid "Failed to update default visibility"
msgstr "Failed to update default visibility"

#: src/pages/settings.jsx:383
msgid "Synced to your instance server's settings. <0>Go to your instance ({instance}) for more settings.</0>"
msgstr ""

#: src/pages/settings.jsx:398
msgid "Experiments"
msgstr ""

#: src/pages/settings.jsx:411
msgid "Auto refresh timeline posts"
msgstr ""

#: src/pages/settings.jsx:423
msgid "Boosts carousel"
msgstr ""

#: src/pages/settings.jsx:440
msgid "Post translation"
msgstr ""

#: src/pages/settings.jsx:451
msgid "Translate to "
msgstr "Translate to "

#: src/pages/settings.jsx:462
msgid "System language ({systemTargetLanguageText})"
msgstr ""

#. placeholder {0}: snapStates.settings.contentTranslationHideLanguages .length
#: src/pages/settings.jsx:488
msgid "{0, plural, =0 {Hide \"Translate\" button for:} other {Hide \"Translate\" button for (#):}}"
msgstr ""

#: src/pages/settings.jsx:543
msgid "Note: This feature uses external translation services, powered by <0>{TRANSLATION_API_NAME}</0>."
msgstr "Note: This feature uses external translation services, powered by <0>{TRANSLATION_API_NAME}</0>."

#: src/pages/settings.jsx:571
msgid "Auto inline translation"
msgstr ""

#: src/pages/settings.jsx:575
msgid "Automatically show translation for posts in timeline. Only works for <0>short</0> posts without content warning, media and poll."
msgstr ""

#: src/pages/settings.jsx:596
msgid "GIF Picker for composer"
msgstr ""

#: src/pages/settings.jsx:600
msgid "Note: This feature uses external GIF search service, powered by <0>GIPHY</0>. G-rated (suitable for viewing by all ages), tracking parameters are stripped, referrer information is omitted from requests, but search queries and IP address information will still reach their servers."
msgstr ""

#: src/pages/settings.jsx:629
msgid "Image description generator"
msgstr ""

#: src/pages/settings.jsx:634
msgid "Only for new images while composing new posts."
msgstr ""

#: src/pages/settings.jsx:641
msgid "Note: This feature uses external AI service, powered by <0>img-alt-api</0>. May not work well. Only for images and in English."
msgstr ""

#: src/pages/settings.jsx:669
msgid "\"Cloud\" import/export for shortcuts settings"
msgstr ""

#: src/pages/settings.jsx:674
msgid "⚠️⚠️⚠️ Very experimental.<0/>Stored in your own profile’s notes. Profile (private) notes are mainly used for other profiles, and hidden for own profile."
msgstr ""

#: src/pages/settings.jsx:685
msgid "Note: This feature uses currently-logged-in instance server API."
msgstr ""

#: src/pages/settings.jsx:702
msgid "Cloak mode <0>(<1>Text</1> → <2>████</2>)</0>"
msgstr ""

#: src/pages/settings.jsx:711
msgid "Replace text as blocks, useful when taking screenshots, for privacy reasons."
msgstr ""

#: src/pages/settings.jsx:736
msgid "About"
msgstr ""

#: src/pages/settings.jsx:775
msgid "<0>Built</0> by <1>@cheeaun</1>"
msgstr ""

#: src/pages/settings.jsx:804
msgid "Sponsor"
msgstr ""

#: src/pages/settings.jsx:812
msgid "Donate"
msgstr "Donate"

#: src/pages/settings.jsx:828
msgid "What's new"
msgstr "What's new"

#: src/pages/settings.jsx:832
msgid "Privacy Policy"
msgstr ""

#. placeholder {0}: WEBSITE.replace(/https?:\/\//g, '').replace(/\/$/, '')
#: src/pages/settings.jsx:839
msgid "<0>Site:</0> {0}"
msgstr ""

#. placeholder {0}: !__FAKE_COMMIT_HASH__ && ( <span class="ib insignificant"> ( <a href={`https://github.com/cheeaun/phanpy/commit/${__COMMIT_HASH__}`} target="_blank" rel="noopener" > <RelativeTime datetime={new Date(__BUILD_TIME__)} /> </a> ) </span> )
#: src/pages/settings.jsx:846
msgid "<0>Version:</0> <1/> {0}"
msgstr ""

#: src/pages/settings.jsx:861
msgid "Version string copied"
msgstr ""

#: src/pages/settings.jsx:864
msgid "Unable to copy version string"
msgstr ""

#: src/pages/settings.jsx:1129
#: src/pages/settings.jsx:1134
msgid "Failed to update subscription. Please try again."
msgstr ""

#: src/pages/settings.jsx:1140
msgid "Failed to remove subscription. Please try again."
msgstr ""

#: src/pages/settings.jsx:1147
msgid "Push Notifications (beta)"
msgstr ""

#: src/pages/settings.jsx:1169
msgid "Push notifications are blocked. Please enable them in your browser settings."
msgstr ""

#. placeholder {0}: [ { value: 'all', label: t`anyone`, }, { value: 'followed', label: t`people I follow`, }, { value: 'follower', label: t`followers`, }, ].map((type) => ( <option value={type.value}>{type.label}</option> ))
#: src/pages/settings.jsx:1178
msgid "Allow from <0>{0}</0>"
msgstr ""

#: src/pages/settings.jsx:1187
msgid "anyone"
msgstr ""

#: src/pages/settings.jsx:1191
msgid "people I follow"
msgstr ""

#: src/pages/settings.jsx:1195
msgid "followers"
msgstr ""

#: src/pages/settings.jsx:1228
msgid "Follows"
msgstr ""

#: src/pages/settings.jsx:1236
msgid "Polls"
msgstr ""

#: src/pages/settings.jsx:1240
msgid "Post edits"
msgstr ""

#: src/pages/settings.jsx:1261
msgid "Push permission was not granted since your last login. You'll need to <0><1>log in</1> again to grant push permission</0>."
msgstr ""

#: src/pages/settings.jsx:1277
msgid "NOTE: Push notifications only work for <0>one account</0>."
msgstr ""

#. js-lingui-explicit-id
#: src/pages/status.jsx:733
#: src/pages/status.jsx:1378
msgid "post.title"
msgstr "Post"

#: src/pages/status.jsx:987
msgid "You're not logged in. Interactions (reply, boost, etc) are not possible."
msgstr ""

#: src/pages/status.jsx:1007
msgid "This post is from another instance (<0>{instance}</0>). Interactions (reply, boost, etc) are not possible."
msgstr ""

#: src/pages/status.jsx:1035
msgid "Error: {e}"
msgstr ""

#: src/pages/status.jsx:1042
msgid "Switch to my instance to enable interactions"
msgstr ""

#: src/pages/status.jsx:1144
msgid "Unable to load replies."
msgstr ""

#: src/pages/status.jsx:1200
msgid "{months, plural, one {# month later} other {# months later}}"
msgstr "{months, plural, one {# month later} other {# months later}}"

#: src/pages/status.jsx:1206
msgid "{years, plural, one {# year later} other {# years later}}"
msgstr "{years, plural, one {# year later} other {# years later}}"

#: src/pages/status.jsx:1338
msgid "Back"
msgstr ""

#: src/pages/status.jsx:1369
msgid "Go to main post"
msgstr ""

#. placeholder {0}: ancestors.length
#: src/pages/status.jsx:1392
msgid "{0} posts above ‒ Go to top"
msgstr ""

#: src/pages/status.jsx:1440
#: src/pages/status.jsx:1503
msgid "Switch to Side Peek view"
msgstr ""

#: src/pages/status.jsx:1504
msgid "Switch to Full view"
msgstr ""

#: src/pages/status.jsx:1522
msgid "Show all sensitive content"
msgstr ""

#: src/pages/status.jsx:1527
msgid "Experimental"
msgstr ""

#: src/pages/status.jsx:1536
msgid "Unable to switch"
msgstr ""

#. placeholder {0}: punycode.toUnicode( postInstance, )
#: src/pages/status.jsx:1543
msgid "Switch to post's instance ({0})"
msgstr "Switch to post's instance ({0})"

#: src/pages/status.jsx:1546
msgid "Switch to post's instance"
msgstr ""

#: src/pages/status.jsx:1559
msgid "View Edit History Snapshots"
msgstr "View Edit History Snapshots"

#: src/pages/status.jsx:1617
msgid "Unable to load post"
msgstr ""

#. placeholder {0}: replies.length
#. placeholder {1}: shortenNumber(replies.length)
#: src/pages/status.jsx:1754
msgid "{0, plural, one {# reply} other {<0>{1}</0> replies}}"
msgstr ""

#. placeholder {0}: shortenNumber(totalComments)
#: src/pages/status.jsx:1772
msgid "{totalComments, plural, one {# comment} other {<0>{0}</0> comments}}"
msgstr ""

#: src/pages/status.jsx:1794
msgid "View post with its replies"
msgstr ""

#: src/pages/trending.jsx:77
msgid "Trending ({instance})"
msgstr ""

#: src/pages/trending.jsx:235
msgid "Trending News"
msgstr ""

#. By [Author]
#. placeholder {0}: author ? ( <NameText account={author} showAvatar /> ) : authorUrl ? ( <a href={authorUrl} target="_blank" rel="noopener" > {authorName} </a> ) : ( authorName )
#: src/pages/trending.jsx:350
msgid "By {0}"
msgstr "By {0}"

#: src/pages/trending.jsx:411
msgid "Back to showing trending posts"
msgstr ""

#. placeholder {0}: currentLink .replace(/^https?:\/\/(www\.)?/i, '') .replace(/\/$/, '')
#: src/pages/trending.jsx:416
msgid "Showing posts mentioning <0>{0}</0>"
msgstr ""

#: src/pages/trending.jsx:428
msgid "Trending posts"
msgstr ""

#: src/pages/trending.jsx:451
msgid "No trending posts."
msgstr ""

#: src/pages/welcome.jsx:54
msgid "A minimalistic opinionated Mastodon web client."
msgstr ""

#: src/pages/welcome.jsx:65
msgid "Log in with Mastodon"
msgstr ""

#: src/pages/welcome.jsx:71
msgid "Sign up"
msgstr ""

#: src/pages/welcome.jsx:78
msgid "Connect your existing Mastodon/Fediverse account.<0/>Your credentials are not stored on this server."
msgstr ""

#: src/pages/welcome.jsx:95
msgid "<0>Built</0> by <1>@cheeaun</1>. <2>Privacy Policy</2>."
msgstr ""

#: src/pages/welcome.jsx:126
msgid "Screenshot of Boosts Carousel"
msgstr ""

#: src/pages/welcome.jsx:130
msgid "Boosts Carousel"
msgstr ""

#: src/pages/welcome.jsx:133
msgid "Visually separate original posts and re-shared posts (boosted posts)."
msgstr ""

#: src/pages/welcome.jsx:142
msgid "Screenshot of Catch-up"
msgstr "Screenshot of Catch-up"

#: src/pages/welcome.jsx:149
msgid "A separate timeline for followings. Email-inspired interface to sort and filter posts."
msgstr "A separate timeline for followings. Email-inspired interface to sort and filter posts."

#: src/pages/welcome.jsx:158
msgid "Screenshot of nested comments thread"
msgstr ""

#: src/pages/welcome.jsx:162
msgid "Nested comments thread"
msgstr ""

#: src/pages/welcome.jsx:165
msgid "Effortlessly follow conversations. Semi-collapsible replies."
msgstr ""

#: src/pages/welcome.jsx:173
msgid "Screenshot of multi-column UI"
msgstr ""

#: src/pages/welcome.jsx:177
msgid "Single or multi-column"
msgstr ""

#: src/pages/welcome.jsx:180
msgid "By default, single column for zen-mode seekers. Configurable multi-column for power users."
msgstr ""

#: src/pages/welcome.jsx:189
msgid "Screenshot of multi-hashtag timeline with a form to add more hashtags"
msgstr ""

#: src/pages/welcome.jsx:193
msgid "Multi-hashtag timeline"
msgstr ""

#: src/pages/welcome.jsx:196
msgid "Up to 5 hashtags combined into a single timeline."
msgstr ""

#: src/utils/open-compose.js:24
msgid "Looks like your browser is blocking popups."
msgstr ""

#: src/utils/show-compose.js:16
msgid "A draft post is currently minimized. Post or discard it before creating a new one."
msgstr ""

#: src/utils/show-compose.js:21
msgid "A post is currently open. Post or discard it before creating a new one."
msgstr ""
